import * as hs from "react";
import Ie, { createContext as Qt, useLayoutEffect as Zi, useEffect as Vn, useContext as Q, useRef as gn, useInsertionEffect as Hi, useCallback as Gi, useMemo as Yt, forwardRef as S, createElement as Ar, useId as zi, memo as A, isValidElement as Ki } from "react";
var Cp = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Yi(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Pp(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(s) {
    var r = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(n, s, r.get ? r : {
      enumerable: !0,
      get: function() {
        return t[s];
      }
    });
  }), n;
}
var Te = { exports: {} }, se = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ds;
function qi() {
  if (ds) return se;
  ds = 1;
  var t = Ie, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, l, c) {
    var u, f = {}, p = null, m = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (u in l) s.call(l, u) && !i.hasOwnProperty(u) && (f[u] = l[u]);
    if (a && a.defaultProps) for (u in l = a.defaultProps, l) f[u] === void 0 && (f[u] = l[u]);
    return { $$typeof: e, type: a, key: p, ref: m, props: f, _owner: r.current };
  }
  return se.Fragment = n, se.jsx = o, se.jsxs = o, se;
}
var re = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ps;
function Ji() {
  return ps || (ps = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ie, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = Symbol.iterator, y = "@@iterator";
    function C(h) {
      if (h === null || typeof h != "object")
        return null;
      var v = g && h[g] || h[y];
      return typeof v == "function" ? v : null;
    }
    var P = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(h) {
      {
        for (var v = arguments.length, b = new Array(v > 1 ? v - 1 : 0), j = 1; j < v; j++)
          b[j - 1] = arguments[j];
        x("error", h, b);
      }
    }
    function x(h, v, b) {
      {
        var j = P.ReactDebugCurrentFrame, E = j.getStackAddendum();
        E !== "" && (v += "%s", b = b.concat([E]));
        var D = b.map(function(k) {
          return String(k);
        });
        D.unshift("Warning: " + v), Function.prototype.apply.call(console[h], console, D);
      }
    }
    var T = !1, R = !1, X = !1, F = !1, L = !1, O;
    O = Symbol.for("react.module.reference");
    function ct(h) {
      return !!(typeof h == "string" || typeof h == "function" || h === s || h === i || L || h === r || h === c || h === u || F || h === m || T || R || X || typeof h == "object" && h !== null && (h.$$typeof === p || h.$$typeof === f || h.$$typeof === o || h.$$typeof === a || h.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      h.$$typeof === O || h.getModuleId !== void 0));
    }
    function Pt(h, v, b) {
      var j = h.displayName;
      if (j)
        return j;
      var E = v.displayName || v.name || "";
      return E !== "" ? b + "(" + E + ")" : b;
    }
    function q(h) {
      return h.displayName || "Context";
    }
    function G(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case s:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case r:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case a:
            var v = h;
            return q(v) + ".Consumer";
          case o:
            var b = h;
            return q(b._context) + ".Provider";
          case l:
            return Pt(h, h.render, "ForwardRef");
          case f:
            var j = h.displayName || null;
            return j !== null ? j : G(h.type) || "Memo";
          case p: {
            var E = h, D = E._payload, k = E._init;
            try {
              return G(k(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, st = 0, U, ut, St, mt, te, _, Tt;
    function ee() {
    }
    ee.__reactDisabledLog = !0;
    function be() {
      {
        if (st === 0) {
          U = console.log, ut = console.info, St = console.warn, mt = console.error, te = console.group, _ = console.groupCollapsed, Tt = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        st++;
      }
    }
    function Ce() {
      {
        if (st--, st === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, h, {
              value: U
            }),
            info: B({}, h, {
              value: ut
            }),
            warn: B({}, h, {
              value: St
            }),
            error: B({}, h, {
              value: mt
            }),
            group: B({}, h, {
              value: te
            }),
            groupCollapsed: B({}, h, {
              value: _
            }),
            groupEnd: B({}, h, {
              value: Tt
            })
          });
        }
        st < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var gt = P.ReactCurrentDispatcher, Xt;
    function It(h, v, b) {
      {
        if (Xt === void 0)
          try {
            throw Error();
          } catch (E) {
            var j = E.stack.trim().match(/\n( *(at )?)/);
            Xt = j && j[1] || "";
          }
        return `
` + Xt + h;
      }
    }
    var Et = !1, yt;
    {
      var vt = typeof WeakMap == "function" ? WeakMap : Map;
      yt = new vt();
    }
    function Ye(h, v) {
      if (!h || Et)
        return "";
      {
        var b = yt.get(h);
        if (b !== void 0)
          return b;
      }
      var j;
      Et = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = gt.current, gt.current = null, be();
      try {
        if (v) {
          var k = function() {
            throw Error();
          };
          if (Object.defineProperty(k.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(k, []);
            } catch (J) {
              j = J;
            }
            Reflect.construct(h, [], k);
          } else {
            try {
              k.call();
            } catch (J) {
              j = J;
            }
            h.call(k.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (J) {
            j = J;
          }
          h();
        }
      } catch (J) {
        if (J && j && typeof J.stack == "string") {
          for (var V = J.stack.split(`
`), K = j.stack.split(`
`), W = V.length - 1, Z = K.length - 1; W >= 1 && Z >= 0 && V[W] !== K[Z]; )
            Z--;
          for (; W >= 1 && Z >= 0; W--, Z--)
            if (V[W] !== K[Z]) {
              if (W !== 1 || Z !== 1)
                do
                  if (W--, Z--, Z < 0 || V[W] !== K[Z]) {
                    var rt = `
` + V[W].replace(" at new ", " at ");
                    return h.displayName && rt.includes("<anonymous>") && (rt = rt.replace("<anonymous>", h.displayName)), typeof h == "function" && yt.set(h, rt), rt;
                  }
                while (W >= 1 && Z >= 0);
              break;
            }
        }
      } finally {
        Et = !1, gt.current = D, Ce(), Error.prepareStackTrace = E;
      }
      var Ut = h ? h.displayName || h.name : "", Dt = Ut ? It(Ut) : "";
      return typeof h == "function" && yt.set(h, Dt), Dt;
    }
    function bi(h, v, b) {
      return Ye(h, !1);
    }
    function Ci(h) {
      var v = h.prototype;
      return !!(v && v.isReactComponent);
    }
    function Pe(h, v, b) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return Ye(h, Ci(h));
      if (typeof h == "string")
        return It(h);
      switch (h) {
        case c:
          return It("Suspense");
        case u:
          return It("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case l:
            return bi(h.render);
          case f:
            return Pe(h.type, v, b);
          case p: {
            var j = h, E = j._payload, D = j._init;
            try {
              return Pe(D(E), v, b);
            } catch {
            }
          }
        }
      return "";
    }
    var ne = Object.prototype.hasOwnProperty, Jn = {}, Qn = P.ReactDebugCurrentFrame;
    function Se(h) {
      if (h) {
        var v = h._owner, b = Pe(h.type, h._source, v ? v.type : null);
        Qn.setExtraStackFrame(b);
      } else
        Qn.setExtraStackFrame(null);
    }
    function Pi(h, v, b, j, E) {
      {
        var D = Function.call.bind(ne);
        for (var k in h)
          if (D(h, k)) {
            var V = void 0;
            try {
              if (typeof h[k] != "function") {
                var K = Error((j || "React class") + ": " + b + " type `" + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[k] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw K.name = "Invariant Violation", K;
              }
              V = h[k](v, k, j, b, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              V = W;
            }
            V && !(V instanceof Error) && (Se(E), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", j || "React class", b, k, typeof V), Se(null)), V instanceof Error && !(V.message in Jn) && (Jn[V.message] = !0, Se(E), w("Failed %s type: %s", b, V.message), Se(null));
          }
      }
    }
    var Si = Array.isArray;
    function qe(h) {
      return Si(h);
    }
    function Ti(h) {
      {
        var v = typeof Symbol == "function" && Symbol.toStringTag, b = v && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return b;
      }
    }
    function Mi(h) {
      try {
        return ts(h), !1;
      } catch {
        return !0;
      }
    }
    function ts(h) {
      return "" + h;
    }
    function es(h) {
      if (Mi(h))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ti(h)), ts(h);
    }
    var ns = P.ReactCurrentOwner, ji = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ss, rs;
    function Ai(h) {
      if (ne.call(h, "ref")) {
        var v = Object.getOwnPropertyDescriptor(h, "ref").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return h.ref !== void 0;
    }
    function Ri(h) {
      if (ne.call(h, "key")) {
        var v = Object.getOwnPropertyDescriptor(h, "key").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return h.key !== void 0;
    }
    function Vi(h, v) {
      typeof h.ref == "string" && ns.current;
    }
    function Li(h, v) {
      {
        var b = function() {
          ss || (ss = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        b.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: b,
          configurable: !0
        });
      }
    }
    function ki(h, v) {
      {
        var b = function() {
          rs || (rs = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        b.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: b,
          configurable: !0
        });
      }
    }
    var Ei = function(h, v, b, j, E, D, k) {
      var V = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: h,
        key: v,
        ref: b,
        props: k,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return V._store = {}, Object.defineProperty(V._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(V, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.defineProperty(V, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(V.props), Object.freeze(V)), V;
    };
    function Di(h, v, b, j, E) {
      {
        var D, k = {}, V = null, K = null;
        b !== void 0 && (es(b), V = "" + b), Ri(v) && (es(v.key), V = "" + v.key), Ai(v) && (K = v.ref, Vi(v, E));
        for (D in v)
          ne.call(v, D) && !ji.hasOwnProperty(D) && (k[D] = v[D]);
        if (h && h.defaultProps) {
          var W = h.defaultProps;
          for (D in W)
            k[D] === void 0 && (k[D] = W[D]);
        }
        if (V || K) {
          var Z = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          V && Li(k, Z), K && ki(k, Z);
        }
        return Ei(h, V, K, E, j, ns.current, k);
      }
    }
    var Je = P.ReactCurrentOwner, os = P.ReactDebugCurrentFrame;
    function Wt(h) {
      if (h) {
        var v = h._owner, b = Pe(h.type, h._source, v ? v.type : null);
        os.setExtraStackFrame(b);
      } else
        os.setExtraStackFrame(null);
    }
    var Qe;
    Qe = !1;
    function tn(h) {
      return typeof h == "object" && h !== null && h.$$typeof === e;
    }
    function is() {
      {
        if (Je.current) {
          var h = G(Je.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
    }
    function _i(h) {
      return "";
    }
    var as = {};
    function Fi(h) {
      {
        var v = is();
        if (!v) {
          var b = typeof h == "string" ? h : h.displayName || h.name;
          b && (v = `

Check the top-level render call using <` + b + ">.");
        }
        return v;
      }
    }
    function ls(h, v) {
      {
        if (!h._store || h._store.validated || h.key != null)
          return;
        h._store.validated = !0;
        var b = Fi(v);
        if (as[b])
          return;
        as[b] = !0;
        var j = "";
        h && h._owner && h._owner !== Je.current && (j = " It was passed a child from " + G(h._owner.type) + "."), Wt(h), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', b, j), Wt(null);
      }
    }
    function cs(h, v) {
      {
        if (typeof h != "object")
          return;
        if (qe(h))
          for (var b = 0; b < h.length; b++) {
            var j = h[b];
            tn(j) && ls(j, v);
          }
        else if (tn(h))
          h._store && (h._store.validated = !0);
        else if (h) {
          var E = C(h);
          if (typeof E == "function" && E !== h.entries)
            for (var D = E.call(h), k; !(k = D.next()).done; )
              tn(k.value) && ls(k.value, v);
        }
      }
    }
    function Oi(h) {
      {
        var v = h.type;
        if (v == null || typeof v == "string")
          return;
        var b;
        if (typeof v == "function")
          b = v.propTypes;
        else if (typeof v == "object" && (v.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        v.$$typeof === f))
          b = v.propTypes;
        else
          return;
        if (b) {
          var j = G(v);
          Pi(b, h.props, "prop", j, h);
        } else if (v.PropTypes !== void 0 && !Qe) {
          Qe = !0;
          var E = G(v);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $i(h) {
      {
        for (var v = Object.keys(h.props), b = 0; b < v.length; b++) {
          var j = v[b];
          if (j !== "children" && j !== "key") {
            Wt(h), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", j), Wt(null);
            break;
          }
        }
        h.ref !== null && (Wt(h), w("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var us = {};
    function fs(h, v, b, j, E, D) {
      {
        var k = ct(h);
        if (!k) {
          var V = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (V += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var K = _i();
          K ? V += K : V += is();
          var W;
          h === null ? W = "null" : qe(h) ? W = "array" : h !== void 0 && h.$$typeof === e ? (W = "<" + (G(h.type) || "Unknown") + " />", V = " Did you accidentally export a JSX literal instead of a component?") : W = typeof h, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, V);
        }
        var Z = Di(h, v, b, E, D);
        if (Z == null)
          return Z;
        if (k) {
          var rt = v.children;
          if (rt !== void 0)
            if (j)
              if (qe(rt)) {
                for (var Ut = 0; Ut < rt.length; Ut++)
                  cs(rt[Ut], h);
                Object.freeze && Object.freeze(rt);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              cs(rt, h);
        }
        if (ne.call(v, "key")) {
          var Dt = G(h), J = Object.keys(v).filter(function(Ui) {
            return Ui !== "key";
          }), en = J.length > 0 ? "{key: someKey, " + J.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!us[Dt + en]) {
            var Wi = J.length > 0 ? "{" + J.join(": ..., ") + ": ...}" : "{}";
            w(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, en, Dt, Wi, Dt), us[Dt + en] = !0;
          }
        }
        return h === s ? $i(Z) : Oi(Z), Z;
      }
    }
    function Bi(h, v, b) {
      return fs(h, v, b, !0);
    }
    function Ni(h, v, b) {
      return fs(h, v, b, !1);
    }
    var Xi = Ni, Ii = Bi;
    re.Fragment = s, re.jsx = Xi, re.jsxs = Ii;
  }()), re;
}
var ms;
function Qi() {
  return ms || (ms = 1, process.env.NODE_ENV === "production" ? Te.exports = qi() : Te.exports = Ji()), Te.exports;
}
var d = Qi();
const Rr = Qt({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
}), We = Qt({}), Ln = Qt(null), Ue = typeof document < "u", ta = Ue ? Zi : Vn, Vr = Qt({ strict: !1 }), kn = (t) => t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), ea = "framerAppearId", Lr = "data-" + kn(ea);
function na(t, e, n, s) {
  const { visualElement: r } = Q(We), i = Q(Vr), o = Q(Ln), a = Q(Rr).reducedMotion, l = gn();
  s = s || i.renderer, !l.current && s && (l.current = s(t, {
    visualState: e,
    parent: r,
    props: n,
    presenceContext: o,
    blockInitialAnimation: o ? o.initial === !1 : !1,
    reducedMotionConfig: a
  }));
  const c = l.current;
  Hi(() => {
    c && c.update(n, o);
  });
  const u = gn(!!(n[Lr] && !window.HandoffComplete));
  return ta(() => {
    c && (c.render(), u.current && c.animationState && c.animationState.animateChanges());
  }), Vn(() => {
    c && (c.updateFeatures(), !u.current && c.animationState && c.animationState.animateChanges(), u.current && (u.current = !1, window.HandoffComplete = !0));
  }), c;
}
function Ht(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function sa(t, e, n) {
  return Gi(
    (s) => {
      s && t.mount && t.mount(s), e && (s ? e.mount(s) : e.unmount()), n && (typeof n == "function" ? n(s) : Ht(n) && (n.current = s));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function de(t) {
  return typeof t == "string" || Array.isArray(t);
}
function Ze(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const En = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Dn = ["initial", ...En];
function He(t) {
  return Ze(t.animate) || Dn.some((e) => de(t[e]));
}
function kr(t) {
  return !!(He(t) || t.variants);
}
function ra(t, e) {
  if (He(t)) {
    const { initial: n, animate: s } = t;
    return {
      initial: n === !1 || de(n) ? n : void 0,
      animate: de(s) ? s : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function oa(t) {
  const { initial: e, animate: n } = ra(t, Q(We));
  return Yt(() => ({ initial: e, animate: n }), [gs(e), gs(n)]);
}
function gs(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const ys = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, pe = {};
for (const t in ys)
  pe[t] = {
    isEnabled: (e) => ys[t].some((n) => !!e[n])
  };
function ia(t) {
  for (const e in t)
    pe[e] = {
      ...pe[e],
      ...t[e]
    };
}
const Er = Qt({}), Dr = Qt({}), aa = Symbol.for("motionComponentSymbol");
function la({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: s, Component: r }) {
  t && ia(t);
  function i(a, l) {
    let c;
    const u = {
      ...Q(Rr),
      ...a,
      layoutId: ca(a)
    }, { isStatic: f } = u, p = oa(a), m = s(a, f);
    if (!f && Ue) {
      p.visualElement = na(r, m, u, e);
      const g = Q(Dr), y = Q(Vr).strict;
      p.visualElement && (c = p.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        u,
        y,
        t,
        g
      ));
    }
    return hs.createElement(
      We.Provider,
      { value: p },
      c && p.visualElement ? hs.createElement(c, { visualElement: p.visualElement, ...u }) : null,
      n(r, a, sa(m, p.visualElement, l), m, f, p.visualElement)
    );
  }
  const o = S(i);
  return o[aa] = r, o;
}
function ca({ layoutId: t }) {
  const e = Q(Er).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function ua(t) {
  function e(s, r = {}) {
    return la(t(s, r));
  }
  if (typeof Proxy > "u")
    return e;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (s, r) => (n.has(r) || n.set(r, e(r)), n.get(r))
  });
}
const fa = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function _n(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(fa.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(t))
    )
  );
}
const De = {};
function ha(t) {
  Object.assign(De, t);
}
const ge = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Bt = new Set(ge);
function _r(t, { layout: e, layoutId: n }) {
  return Bt.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!De[t] || t === "opacity");
}
const tt = (t) => !!(t && t.getVelocity), da = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, pa = ge.length;
function ma(t, { enableHardwareAcceleration: e = !0, allowTransformNone: n = !0 }, s, r) {
  let i = "";
  for (let o = 0; o < pa; o++) {
    const a = ge[o];
    if (t[a] !== void 0) {
      const l = da[a] || a;
      i += `${l}(${t[a]}) `;
    }
  }
  return e && !t.z && (i += "translateZ(0)"), i = i.trim(), r ? i = r(t, s ? "" : i) : n && s && (i = "none"), i;
}
const Fr = (t) => (e) => typeof e == "string" && e.startsWith(t), Or = Fr("--"), yn = Fr("var(--"), ga = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, ya = (t, e) => e && typeof t == "number" ? e.transform(t) : t, Vt = (t, e, n) => Math.min(Math.max(n, t), e), Nt = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, ce = {
  ...Nt,
  transform: (t) => Vt(0, 1, t)
}, Me = {
  ...Nt,
  default: 1
}, ue = (t) => Math.round(t * 1e5) / 1e5, Ge = /(-)?([\d]*\.?[\d])+/g, $r = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, va = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function ye(t) {
  return typeof t == "string";
}
const ve = (t) => ({
  test: (e) => ye(e) && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Mt = ve("deg"), dt = ve("%"), M = ve("px"), xa = ve("vh"), wa = ve("vw"), vs = {
  ...dt,
  parse: (t) => dt.parse(t) / 100,
  transform: (t) => dt.transform(t * 100)
}, xs = {
  ...Nt,
  transform: Math.round
}, Br = {
  // Border props
  borderWidth: M,
  borderTopWidth: M,
  borderRightWidth: M,
  borderBottomWidth: M,
  borderLeftWidth: M,
  borderRadius: M,
  radius: M,
  borderTopLeftRadius: M,
  borderTopRightRadius: M,
  borderBottomRightRadius: M,
  borderBottomLeftRadius: M,
  // Positioning props
  width: M,
  maxWidth: M,
  height: M,
  maxHeight: M,
  size: M,
  top: M,
  right: M,
  bottom: M,
  left: M,
  // Spacing props
  padding: M,
  paddingTop: M,
  paddingRight: M,
  paddingBottom: M,
  paddingLeft: M,
  margin: M,
  marginTop: M,
  marginRight: M,
  marginBottom: M,
  marginLeft: M,
  // Transform props
  rotate: Mt,
  rotateX: Mt,
  rotateY: Mt,
  rotateZ: Mt,
  scale: Me,
  scaleX: Me,
  scaleY: Me,
  scaleZ: Me,
  skew: Mt,
  skewX: Mt,
  skewY: Mt,
  distance: M,
  translateX: M,
  translateY: M,
  translateZ: M,
  x: M,
  y: M,
  z: M,
  perspective: M,
  transformPerspective: M,
  opacity: ce,
  originX: vs,
  originY: vs,
  originZ: M,
  // Misc
  zIndex: xs,
  // SVG
  fillOpacity: ce,
  strokeOpacity: ce,
  numOctaves: xs
};
function Fn(t, e, n, s) {
  const { style: r, vars: i, transform: o, transformOrigin: a } = t;
  let l = !1, c = !1, u = !0;
  for (const f in e) {
    const p = e[f];
    if (Or(f)) {
      i[f] = p;
      continue;
    }
    const m = Br[f], g = ya(p, m);
    if (Bt.has(f)) {
      if (l = !0, o[f] = g, !u)
        continue;
      p !== (m.default || 0) && (u = !1);
    } else f.startsWith("origin") ? (c = !0, a[f] = g) : r[f] = g;
  }
  if (e.transform || (l || s ? r.transform = ma(t.transform, n, u, s) : r.transform && (r.transform = "none")), c) {
    const { originX: f = "50%", originY: p = "50%", originZ: m = 0 } = a;
    r.transformOrigin = `${f} ${p} ${m}`;
  }
}
const On = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Nr(t, e, n) {
  for (const s in e)
    !tt(e[s]) && !_r(s, n) && (t[s] = e[s]);
}
function ba({ transformTemplate: t }, e, n) {
  return Yt(() => {
    const s = On();
    return Fn(s, e, { enableHardwareAcceleration: !n }, t), Object.assign({}, s.vars, s.style);
  }, [e]);
}
function Ca(t, e, n) {
  const s = t.style || {}, r = {};
  return Nr(r, s, t), Object.assign(r, ba(t, e, n)), t.transformValues ? t.transformValues(r) : r;
}
function Pa(t, e, n) {
  const s = {}, r = Ca(t, e, n);
  return t.drag && t.dragListener !== !1 && (s.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (s.tabIndex = 0), s.style = r, s;
}
const Sa = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function _e(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || Sa.has(t);
}
let Xr = (t) => !_e(t);
function Ta(t) {
  t && (Xr = (e) => e.startsWith("on") ? !_e(e) : t(e));
}
try {
  Ta(require("@emotion/is-prop-valid").default);
} catch {
}
function Ma(t, e, n) {
  const s = {};
  for (const r in t)
    r === "values" && typeof t.values == "object" || (Xr(r) || n === !0 && _e(r) || !e && !_e(r) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && r.startsWith("onDrag")) && (s[r] = t[r]);
  return s;
}
function ws(t, e, n) {
  return typeof t == "string" ? t : M.transform(e + n * t);
}
function ja(t, e, n) {
  const s = ws(e, t.x, t.width), r = ws(n, t.y, t.height);
  return `${s} ${r}`;
}
const Aa = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Ra = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Va(t, e, n = 1, s = 0, r = !0) {
  t.pathLength = 1;
  const i = r ? Aa : Ra;
  t[i.offset] = M.transform(-s);
  const o = M.transform(e), a = M.transform(n);
  t[i.array] = `${o} ${a}`;
}
function $n(t, {
  attrX: e,
  attrY: n,
  attrScale: s,
  originX: r,
  originY: i,
  pathLength: o,
  pathSpacing: a = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, f, p) {
  if (Fn(t, c, u, p), f) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: m, style: g, dimensions: y } = t;
  m.transform && (y && (g.transform = m.transform), delete m.transform), y && (r !== void 0 || i !== void 0 || g.transform) && (g.transformOrigin = ja(y, r !== void 0 ? r : 0.5, i !== void 0 ? i : 0.5)), e !== void 0 && (m.x = e), n !== void 0 && (m.y = n), s !== void 0 && (m.scale = s), o !== void 0 && Va(m, o, a, l, !1);
}
const Ir = () => ({
  ...On(),
  attrs: {}
}), Bn = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function La(t, e, n, s) {
  const r = Yt(() => {
    const i = Ir();
    return $n(i, e, { enableHardwareAcceleration: !1 }, Bn(s), t.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [e]);
  if (t.style) {
    const i = {};
    Nr(i, t.style, t), r.style = { ...i, ...r.style };
  }
  return r;
}
function ka(t = !1) {
  return (n, s, r, { latestValues: i }, o) => {
    const l = (_n(n) ? La : Pa)(s, i, o, n), u = {
      ...Ma(s, typeof n == "string", t),
      ...l,
      ref: r
    }, { children: f } = s, p = Yt(() => tt(f) ? f.get() : f, [f]);
    return Ar(n, {
      ...u,
      children: p
    });
  };
}
function Wr(t, { style: e, vars: n }, s, r) {
  Object.assign(t.style, e, r && r.getProjectionStyles(s));
  for (const i in n)
    t.style.setProperty(i, n[i]);
}
const Ur = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Zr(t, e, n, s) {
  Wr(t, e, void 0, s);
  for (const r in e.attrs)
    t.setAttribute(Ur.has(r) ? r : kn(r), e.attrs[r]);
}
function Nn(t, e) {
  const { style: n } = t, s = {};
  for (const r in n)
    (tt(n[r]) || e.style && tt(e.style[r]) || _r(r, t)) && (s[r] = n[r]);
  return s;
}
function Hr(t, e) {
  const n = Nn(t, e);
  for (const s in t)
    if (tt(t[s]) || tt(e[s])) {
      const r = ge.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
      n[r] = t[s];
    }
  return n;
}
function Xn(t, e, n, s = {}, r = {}) {
  return typeof e == "function" && (e = e(n !== void 0 ? n : t.custom, s, r)), typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function" && (e = e(n !== void 0 ? n : t.custom, s, r)), e;
}
function Ea(t) {
  const e = gn(null);
  return e.current === null && (e.current = t()), e.current;
}
const Fe = (t) => Array.isArray(t), Da = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), _a = (t) => Fe(t) ? t[t.length - 1] || 0 : t;
function ke(t) {
  const e = tt(t) ? t.get() : t;
  return Da(e) ? e.toValue() : e;
}
function Fa({ scrapeMotionValuesFromProps: t, createRenderState: e, onMount: n }, s, r, i) {
  const o = {
    latestValues: Oa(s, r, i, t),
    renderState: e()
  };
  return n && (o.mount = (a) => n(s, a, o)), o;
}
const Gr = (t) => (e, n) => {
  const s = Q(We), r = Q(Ln), i = () => Fa(t, e, s, r);
  return n ? i() : Ea(i);
};
function Oa(t, e, n, s) {
  const r = {}, i = s(t, {});
  for (const p in i)
    r[p] = ke(i[p]);
  let { initial: o, animate: a } = t;
  const l = He(t), c = kr(t);
  e && c && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), a === void 0 && (a = e.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || o === !1;
  const f = u ? a : o;
  return f && typeof f != "boolean" && !Ze(f) && (Array.isArray(f) ? f : [f]).forEach((m) => {
    const g = Xn(t, m);
    if (!g)
      return;
    const { transitionEnd: y, transition: C, ...P } = g;
    for (const w in P) {
      let x = P[w];
      if (Array.isArray(x)) {
        const T = u ? x.length - 1 : 0;
        x = x[T];
      }
      x !== null && (r[w] = x);
    }
    for (const w in y)
      r[w] = y[w];
  }), r;
}
const I = (t) => t;
class bs {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(e) {
    if (!this.scheduled.has(e))
      return this.scheduled.add(e), this.order.push(e), !0;
  }
  remove(e) {
    const n = this.order.indexOf(e);
    n !== -1 && (this.order.splice(n, 1), this.scheduled.delete(e));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function $a(t) {
  let e = new bs(), n = new bs(), s = 0, r = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet(), a = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (l, c = !1, u = !1) => {
      const f = u && r, p = f ? e : n;
      return c && o.add(l), p.add(l) && f && r && (s = e.order.length), l;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (l) => {
      n.remove(l), o.delete(l);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (l) => {
      if (r) {
        i = !0;
        return;
      }
      if (r = !0, [e, n] = [n, e], n.clear(), s = e.order.length, s)
        for (let c = 0; c < s; c++) {
          const u = e.order[c];
          u(l), o.has(u) && (a.schedule(u), t());
        }
      r = !1, i && (i = !1, a.process(l));
    }
  };
  return a;
}
const je = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], Ba = 40;
function Na(t, e) {
  let n = !1, s = !0;
  const r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = je.reduce((f, p) => (f[p] = $a(() => n = !0), f), {}), o = (f) => i[f].process(r), a = () => {
    const f = performance.now();
    n = !1, r.delta = s ? 1e3 / 60 : Math.max(Math.min(f - r.timestamp, Ba), 1), r.timestamp = f, r.isProcessing = !0, je.forEach(o), r.isProcessing = !1, n && e && (s = !1, t(a));
  }, l = () => {
    n = !0, s = !0, r.isProcessing || t(a);
  };
  return { schedule: je.reduce((f, p) => {
    const m = i[p];
    return f[p] = (g, y = !1, C = !1) => (n || l(), m.schedule(g, y, C)), f;
  }, {}), cancel: (f) => je.forEach((p) => i[p].cancel(f)), state: r, steps: i };
}
const { schedule: $, cancel: Ct, state: z, steps: nn } = Na(typeof requestAnimationFrame < "u" ? requestAnimationFrame : I, !0), Xa = {
  useVisualState: Gr({
    scrapeMotionValuesFromProps: Hr,
    createRenderState: Ir,
    onMount: (t, e, { renderState: n, latestValues: s }) => {
      $.read(() => {
        try {
          n.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), $.render(() => {
        $n(n, s, { enableHardwareAcceleration: !1 }, Bn(e.tagName), t.transformTemplate), Zr(e, n);
      });
    }
  })
}, Ia = {
  useVisualState: Gr({
    scrapeMotionValuesFromProps: Nn,
    createRenderState: On
  })
};
function Wa(t, { forwardMotionProps: e = !1 }, n, s) {
  return {
    ..._n(t) ? Xa : Ia,
    preloadedFeatures: n,
    useRender: ka(e),
    createVisualElement: s,
    Component: t
  };
}
function xt(t, e, n, s = { passive: !0 }) {
  return t.addEventListener(e, n, s), () => t.removeEventListener(e, n);
}
const zr = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function ze(t, e = "page") {
  return {
    point: {
      x: t[e + "X"],
      y: t[e + "Y"]
    }
  };
}
const Ua = (t) => (e) => zr(e) && t(e, ze(e));
function wt(t, e, n, s) {
  return xt(t, e, Ua(n), s);
}
const Za = (t, e) => (n) => e(t(n)), At = (...t) => t.reduce(Za);
function Kr(t) {
  let e = null;
  return () => {
    const n = () => {
      e = null;
    };
    return e === null ? (e = t, n) : !1;
  };
}
const Cs = Kr("dragHorizontal"), Ps = Kr("dragVertical");
function Yr(t) {
  let e = !1;
  if (t === "y")
    e = Ps();
  else if (t === "x")
    e = Cs();
  else {
    const n = Cs(), s = Ps();
    n && s ? e = () => {
      n(), s();
    } : (n && n(), s && s());
  }
  return e;
}
function qr() {
  const t = Yr(!0);
  return t ? (t(), !1) : !0;
}
class kt {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function Ss(t, e) {
  const n = "pointer" + (e ? "enter" : "leave"), s = "onHover" + (e ? "Start" : "End"), r = (i, o) => {
    if (i.pointerType === "touch" || qr())
      return;
    const a = t.getProps();
    t.animationState && a.whileHover && t.animationState.setActive("whileHover", e), a[s] && $.update(() => a[s](i, o));
  };
  return wt(t.current, n, r, {
    passive: !t.getProps()[s]
  });
}
class Ha extends kt {
  mount() {
    this.unmount = At(Ss(this.node, !0), Ss(this.node, !1));
  }
  unmount() {
  }
}
class Ga extends kt {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = At(xt(this.node.current, "focus", () => this.onFocus()), xt(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const Jr = (t, e) => e ? t === e ? !0 : Jr(t, e.parentElement) : !1;
function sn(t, e) {
  if (!e)
    return;
  const n = new PointerEvent("pointer" + t);
  e(n, ze(n));
}
class za extends kt {
  constructor() {
    super(...arguments), this.removeStartListeners = I, this.removeEndListeners = I, this.removeAccessibleListeners = I, this.startPointerPress = (e, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const s = this.node.getProps(), i = wt(window, "pointerup", (a, l) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: c, onTapCancel: u, globalTapTarget: f } = this.node.getProps();
        $.update(() => {
          !f && !Jr(this.node.current, a.target) ? u && u(a, l) : c && c(a, l);
        });
      }, { passive: !(s.onTap || s.onPointerUp) }), o = wt(window, "pointercancel", (a, l) => this.cancelPress(a, l), { passive: !(s.onTapCancel || s.onPointerCancel) });
      this.removeEndListeners = At(i, o), this.startPress(e, n);
    }, this.startAccessiblePress = () => {
      const e = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const o = (a) => {
          a.key !== "Enter" || !this.checkPressEnd() || sn("up", (l, c) => {
            const { onTap: u } = this.node.getProps();
            u && $.update(() => u(l, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = xt(this.node.current, "keyup", o), sn("down", (a, l) => {
          this.startPress(a, l);
        });
      }, n = xt(this.node.current, "keydown", e), s = () => {
        this.isPressing && sn("cancel", (i, o) => this.cancelPress(i, o));
      }, r = xt(this.node.current, "blur", s);
      this.removeAccessibleListeners = At(n, r);
    };
  }
  startPress(e, n) {
    this.isPressing = !0;
    const { onTapStart: s, whileTap: r } = this.node.getProps();
    r && this.node.animationState && this.node.animationState.setActive("whileTap", !0), s && $.update(() => s(e, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !qr();
  }
  cancelPress(e, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: s } = this.node.getProps();
    s && $.update(() => s(e, n));
  }
  mount() {
    const e = this.node.getProps(), n = wt(e.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(e.onTapStart || e.onPointerStart) }), s = xt(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = At(n, s);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const vn = /* @__PURE__ */ new WeakMap(), rn = /* @__PURE__ */ new WeakMap(), Ka = (t) => {
  const e = vn.get(t.target);
  e && e(t);
}, Ya = (t) => {
  t.forEach(Ka);
};
function qa({ root: t, ...e }) {
  const n = t || document;
  rn.has(n) || rn.set(n, {});
  const s = rn.get(n), r = JSON.stringify(e);
  return s[r] || (s[r] = new IntersectionObserver(Ya, { root: t, ...e })), s[r];
}
function Ja(t, e, n) {
  const s = qa(e);
  return vn.set(t, n), s.observe(t), () => {
    vn.delete(t), s.unobserve(t);
  };
}
const Qa = {
  some: 0,
  all: 1
};
class tl extends kt {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: s, amount: r = "some", once: i } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: s,
      threshold: typeof r == "number" ? r : Qa[r]
    }, a = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: f } = this.node.getProps(), p = c ? u : f;
      p && p(l);
    };
    return Ja(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(el(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function el({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const nl = {
  inView: {
    Feature: tl
  },
  tap: {
    Feature: za
  },
  focus: {
    Feature: Ga
  },
  hover: {
    Feature: Ha
  }
};
function Qr(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let s = 0; s < n; s++)
    if (e[s] !== t[s])
      return !1;
  return !0;
}
function sl(t) {
  const e = {};
  return t.values.forEach((n, s) => e[s] = n.get()), e;
}
function rl(t) {
  const e = {};
  return t.values.forEach((n, s) => e[s] = n.getVelocity()), e;
}
function Ke(t, e, n) {
  const s = t.getProps();
  return Xn(s, e, n !== void 0 ? n : s.custom, sl(t), rl(t));
}
let xe = I, ft = I;
process.env.NODE_ENV !== "production" && (xe = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, ft = (t, e) => {
  if (!t)
    throw new Error(e);
});
const Rt = (t) => t * 1e3, bt = (t) => t / 1e3, ol = {
  current: !1
}, to = (t) => Array.isArray(t) && typeof t[0] == "number";
function eo(t) {
  return !!(!t || typeof t == "string" && no[t] || to(t) || Array.isArray(t) && t.every(eo));
}
const le = ([t, e, n, s]) => `cubic-bezier(${t}, ${e}, ${n}, ${s})`, no = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: le([0, 0.65, 0.55, 1]),
  circOut: le([0.55, 0, 1, 0.45]),
  backIn: le([0.31, 0.01, 0.66, -0.59]),
  backOut: le([0.33, 1.53, 0.69, 0.99])
};
function so(t) {
  if (t)
    return to(t) ? le(t) : Array.isArray(t) ? t.map(so) : no[t];
}
function il(t, e, n, { delay: s = 0, duration: r, repeat: i = 0, repeatType: o = "loop", ease: a, times: l } = {}) {
  const c = { [e]: n };
  l && (c.offset = l);
  const u = so(a);
  return Array.isArray(u) && (c.easing = u), t.animate(c, {
    delay: s,
    duration: r,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: i + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
function al(t, { repeat: e, repeatType: n = "loop" }) {
  const s = e && n !== "loop" && e % 2 === 1 ? 0 : t.length - 1;
  return t[s];
}
const ro = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, ll = 1e-7, cl = 12;
function ul(t, e, n, s, r) {
  let i, o, a = 0;
  do
    o = e + (n - e) / 2, i = ro(o, s, r) - t, i > 0 ? n = o : e = o;
  while (Math.abs(i) > ll && ++a < cl);
  return o;
}
function we(t, e, n, s) {
  if (t === e && n === s)
    return I;
  const r = (i) => ul(i, 0, 1, t, n);
  return (i) => i === 0 || i === 1 ? i : ro(r(i), e, s);
}
const fl = we(0.42, 0, 1, 1), hl = we(0, 0, 0.58, 1), oo = we(0.42, 0, 0.58, 1), dl = (t) => Array.isArray(t) && typeof t[0] != "number", io = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, ao = (t) => (e) => 1 - t(1 - e), In = (t) => 1 - Math.sin(Math.acos(t)), lo = ao(In), pl = io(In), co = we(0.33, 1.53, 0.69, 0.99), Wn = ao(co), ml = io(Wn), gl = (t) => (t *= 2) < 1 ? 0.5 * Wn(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Ts = {
  linear: I,
  easeIn: fl,
  easeInOut: oo,
  easeOut: hl,
  circIn: In,
  circInOut: pl,
  circOut: lo,
  backIn: Wn,
  backInOut: ml,
  backOut: co,
  anticipate: gl
}, Ms = (t) => {
  if (Array.isArray(t)) {
    ft(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, s, r] = t;
    return we(e, n, s, r);
  } else if (typeof t == "string")
    return ft(Ts[t] !== void 0, `Invalid easing type '${t}'`), Ts[t];
  return t;
}, Un = (t, e) => (n) => !!(ye(n) && va.test(n) && n.startsWith(t) || e && Object.prototype.hasOwnProperty.call(n, e)), uo = (t, e, n) => (s) => {
  if (!ye(s))
    return s;
  const [r, i, o, a] = s.match(Ge);
  return {
    [t]: parseFloat(r),
    [e]: parseFloat(i),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, yl = (t) => Vt(0, 255, t), on = {
  ...Nt,
  transform: (t) => Math.round(yl(t))
}, $t = {
  test: Un("rgb", "red"),
  parse: uo("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: s = 1 }) => "rgba(" + on.transform(t) + ", " + on.transform(e) + ", " + on.transform(n) + ", " + ue(ce.transform(s)) + ")"
};
function vl(t) {
  let e = "", n = "", s = "", r = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), r = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), r = t.substring(4, 5), e += e, n += n, s += s, r += r), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(s, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const xn = {
  test: Un("#"),
  parse: vl,
  transform: $t.transform
}, Gt = {
  test: Un("hsl", "hue"),
  parse: uo("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 }) => "hsla(" + Math.round(t) + ", " + dt.transform(ue(e)) + ", " + dt.transform(ue(n)) + ", " + ue(ce.transform(s)) + ")"
}, Y = {
  test: (t) => $t.test(t) || xn.test(t) || Gt.test(t),
  parse: (t) => $t.test(t) ? $t.parse(t) : Gt.test(t) ? Gt.parse(t) : xn.parse(t),
  transform: (t) => ye(t) ? t : t.hasOwnProperty("red") ? $t.transform(t) : Gt.transform(t)
}, N = (t, e, n) => -n * t + n * e + t;
function an(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function xl({ hue: t, saturation: e, lightness: n, alpha: s }) {
  t /= 360, e /= 100, n /= 100;
  let r = 0, i = 0, o = 0;
  if (!e)
    r = i = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    r = an(l, a, t + 1 / 3), i = an(l, a, t), o = an(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(i * 255),
    blue: Math.round(o * 255),
    alpha: s
  };
}
const ln = (t, e, n) => {
  const s = t * t;
  return Math.sqrt(Math.max(0, n * (e * e - s) + s));
}, wl = [xn, $t, Gt], bl = (t) => wl.find((e) => e.test(t));
function js(t) {
  const e = bl(t);
  ft(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`);
  let n = e.parse(t);
  return e === Gt && (n = xl(n)), n;
}
const fo = (t, e) => {
  const n = js(t), s = js(e), r = { ...n };
  return (i) => (r.red = ln(n.red, s.red, i), r.green = ln(n.green, s.green, i), r.blue = ln(n.blue, s.blue, i), r.alpha = N(n.alpha, s.alpha, i), $t.transform(r));
};
function Cl(t) {
  var e, n;
  return isNaN(t) && ye(t) && (((e = t.match(Ge)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match($r)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const ho = {
  regex: ga,
  countKey: "Vars",
  token: "${v}",
  parse: I
}, po = {
  regex: $r,
  countKey: "Colors",
  token: "${c}",
  parse: Y.parse
}, mo = {
  regex: Ge,
  countKey: "Numbers",
  token: "${n}",
  parse: Nt.parse
};
function cn(t, { regex: e, countKey: n, token: s, parse: r }) {
  const i = t.tokenised.match(e);
  i && (t["num" + n] = i.length, t.tokenised = t.tokenised.replace(e, s), t.values.push(...i.map(r)));
}
function Oe(t) {
  const e = t.toString(), n = {
    value: e,
    tokenised: e,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && cn(n, ho), cn(n, po), cn(n, mo), n;
}
function go(t) {
  return Oe(t).values;
}
function yo(t) {
  const { values: e, numColors: n, numVars: s, tokenised: r } = Oe(t), i = e.length;
  return (o) => {
    let a = r;
    for (let l = 0; l < i; l++)
      l < s ? a = a.replace(ho.token, o[l]) : l < s + n ? a = a.replace(po.token, Y.transform(o[l])) : a = a.replace(mo.token, ue(o[l]));
    return a;
  };
}
const Pl = (t) => typeof t == "number" ? 0 : t;
function Sl(t) {
  const e = go(t);
  return yo(t)(e.map(Pl));
}
const Lt = {
  test: Cl,
  parse: go,
  createTransformer: yo,
  getAnimatableNone: Sl
}, vo = (t, e) => (n) => `${n > 0 ? e : t}`;
function xo(t, e) {
  return typeof t == "number" ? (n) => N(t, e, n) : Y.test(t) ? fo(t, e) : t.startsWith("var(") ? vo(t, e) : bo(t, e);
}
const wo = (t, e) => {
  const n = [...t], s = n.length, r = t.map((i, o) => xo(i, e[o]));
  return (i) => {
    for (let o = 0; o < s; o++)
      n[o] = r[o](i);
    return n;
  };
}, Tl = (t, e) => {
  const n = { ...t, ...e }, s = {};
  for (const r in n)
    t[r] !== void 0 && e[r] !== void 0 && (s[r] = xo(t[r], e[r]));
  return (r) => {
    for (const i in s)
      n[i] = s[i](r);
    return n;
  };
}, bo = (t, e) => {
  const n = Lt.createTransformer(e), s = Oe(t), r = Oe(e);
  return s.numVars === r.numVars && s.numColors === r.numColors && s.numNumbers >= r.numNumbers ? At(wo(s.values, r.values), n) : (xe(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), vo(t, e));
}, me = (t, e, n) => {
  const s = e - t;
  return s === 0 ? 1 : (n - t) / s;
}, As = (t, e) => (n) => N(t, e, n);
function Ml(t) {
  return typeof t == "number" ? As : typeof t == "string" ? Y.test(t) ? fo : bo : Array.isArray(t) ? wo : typeof t == "object" ? Tl : As;
}
function jl(t, e, n) {
  const s = [], r = n || Ml(t[0]), i = t.length - 1;
  for (let o = 0; o < i; o++) {
    let a = r(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || I : e;
      a = At(l, a);
    }
    s.push(a);
  }
  return s;
}
function Co(t, e, { clamp: n = !0, ease: s, mixer: r } = {}) {
  const i = t.length;
  if (ft(i === e.length, "Both input and output ranges must be the same length"), i === 1)
    return () => e[0];
  t[0] > t[i - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const o = jl(e, s, r), a = o.length, l = (c) => {
    let u = 0;
    if (a > 1)
      for (; u < t.length - 2 && !(c < t[u + 1]); u++)
        ;
    const f = me(t[u], t[u + 1], c);
    return o[u](f);
  };
  return n ? (c) => l(Vt(t[0], t[i - 1], c)) : l;
}
function Al(t, e) {
  const n = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const r = me(0, e, s);
    t.push(N(n, 1, r));
  }
}
function Rl(t) {
  const e = [0];
  return Al(e, t.length - 1), e;
}
function Vl(t, e) {
  return t.map((n) => n * e);
}
function Ll(t, e) {
  return t.map(() => e || oo).splice(0, t.length - 1);
}
function $e({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
  const r = dl(s) ? s.map(Ms) : Ms(s), i = {
    done: !1,
    value: e[0]
  }, o = Vl(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Rl(e),
    t
  ), a = Co(o, e, {
    ease: Array.isArray(r) ? r : Ll(e, r)
  });
  return {
    calculatedDuration: t,
    next: (l) => (i.value = a(l), i.done = l >= t, i)
  };
}
function Po(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const kl = 5;
function So(t, e, n) {
  const s = Math.max(e - kl, 0);
  return Po(n - t(s), e - s);
}
const Rs = 1e-3, El = 0.01, Vs = 10, Dl = 0.05, _l = 1;
function Fl({ duration: t = 800, bounce: e = 0.25, velocity: n = 0, mass: s = 1 }) {
  let r, i;
  xe(t <= Rt(Vs), "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = Vt(Dl, _l, o), t = Vt(El, Vs, bt(t)), o < 1 ? (r = (c) => {
    const u = c * o, f = u * t, p = u - n, m = wn(c, o), g = Math.exp(-f);
    return Rs - p / m * g;
  }, i = (c) => {
    const f = c * o * t, p = f * n + n, m = Math.pow(o, 2) * Math.pow(c, 2) * t, g = Math.exp(-f), y = wn(Math.pow(c, 2), o);
    return (-r(c) + Rs > 0 ? -1 : 1) * ((p - m) * g) / y;
  }) : (r = (c) => {
    const u = Math.exp(-c * t), f = (c - n) * t + 1;
    return -1e-3 + u * f;
  }, i = (c) => {
    const u = Math.exp(-c * t), f = (n - c) * (t * t);
    return u * f;
  });
  const a = 5 / t, l = $l(r, i, a);
  if (t = Rt(t), isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * s;
    return {
      stiffness: c,
      damping: o * 2 * Math.sqrt(s * c),
      duration: t
    };
  }
}
const Ol = 12;
function $l(t, e, n) {
  let s = n;
  for (let r = 1; r < Ol; r++)
    s = s - t(s) / e(s);
  return s;
}
function wn(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Bl = ["duration", "bounce"], Nl = ["stiffness", "damping", "mass"];
function Ls(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Xl(t) {
  let e = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Ls(t, Nl) && Ls(t, Bl)) {
    const n = Fl(t);
    e = {
      ...e,
      ...n,
      mass: 1
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function To({ keyframes: t, restDelta: e, restSpeed: n, ...s }) {
  const r = t[0], i = t[t.length - 1], o = { done: !1, value: r }, { stiffness: a, damping: l, mass: c, duration: u, velocity: f, isResolvedFromDuration: p } = Xl({
    ...s,
    velocity: -bt(s.velocity || 0)
  }), m = f || 0, g = l / (2 * Math.sqrt(a * c)), y = i - r, C = bt(Math.sqrt(a / c)), P = Math.abs(y) < 5;
  n || (n = P ? 0.01 : 2), e || (e = P ? 5e-3 : 0.5);
  let w;
  if (g < 1) {
    const x = wn(C, g);
    w = (T) => {
      const R = Math.exp(-g * C * T);
      return i - R * ((m + g * C * y) / x * Math.sin(x * T) + y * Math.cos(x * T));
    };
  } else if (g === 1)
    w = (x) => i - Math.exp(-C * x) * (y + (m + C * y) * x);
  else {
    const x = C * Math.sqrt(g * g - 1);
    w = (T) => {
      const R = Math.exp(-g * C * T), X = Math.min(x * T, 300);
      return i - R * ((m + g * C * y) * Math.sinh(X) + x * y * Math.cosh(X)) / x;
    };
  }
  return {
    calculatedDuration: p && u || null,
    next: (x) => {
      const T = w(x);
      if (p)
        o.done = x >= u;
      else {
        let R = m;
        x !== 0 && (g < 1 ? R = So(w, x, T) : R = 0);
        const X = Math.abs(R) <= n, F = Math.abs(i - T) <= e;
        o.done = X && F;
      }
      return o.value = o.done ? i : T, o;
    }
  };
}
function ks({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: s = 325, bounceDamping: r = 10, bounceStiffness: i = 500, modifyTarget: o, min: a, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const f = t[0], p = {
    done: !1,
    value: f
  }, m = (L) => a !== void 0 && L < a || l !== void 0 && L > l, g = (L) => a === void 0 ? l : l === void 0 || Math.abs(a - L) < Math.abs(l - L) ? a : l;
  let y = n * e;
  const C = f + y, P = o === void 0 ? C : o(C);
  P !== C && (y = P - f);
  const w = (L) => -y * Math.exp(-L / s), x = (L) => P + w(L), T = (L) => {
    const O = w(L), ct = x(L);
    p.done = Math.abs(O) <= c, p.value = p.done ? P : ct;
  };
  let R, X;
  const F = (L) => {
    m(p.value) && (R = L, X = To({
      keyframes: [p.value, g(p.value)],
      velocity: So(x, L, p.value),
      damping: r,
      stiffness: i,
      restDelta: c,
      restSpeed: u
    }));
  };
  return F(0), {
    calculatedDuration: null,
    next: (L) => {
      let O = !1;
      return !X && R === void 0 && (O = !0, T(L), F(L)), R !== void 0 && L > R ? X.next(L - R) : (!O && T(L), p);
    }
  };
}
const Il = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => $.update(e, !0),
    stop: () => Ct(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => z.isProcessing ? z.timestamp : performance.now()
  };
}, Es = 2e4;
function Ds(t) {
  let e = 0;
  const n = 50;
  let s = t.next(e);
  for (; !s.done && e < Es; )
    e += n, s = t.next(e);
  return e >= Es ? 1 / 0 : e;
}
const Wl = {
  decay: ks,
  inertia: ks,
  tween: $e,
  keyframes: $e,
  spring: To
};
function Be({ autoplay: t = !0, delay: e = 0, driver: n = Il, keyframes: s, type: r = "keyframes", repeat: i = 0, repeatDelay: o = 0, repeatType: a = "loop", onPlay: l, onStop: c, onComplete: u, onUpdate: f, ...p }) {
  let m = 1, g = !1, y, C;
  const P = () => {
    C = new Promise((_) => {
      y = _;
    });
  };
  P();
  let w;
  const x = Wl[r] || $e;
  let T;
  x !== $e && typeof s[0] != "number" && (process.env.NODE_ENV !== "production" && ft(s.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${s}`), T = Co([0, 100], s, {
    clamp: !1
  }), s = [0, 100]);
  const R = x({ ...p, keyframes: s });
  let X;
  a === "mirror" && (X = x({
    ...p,
    keyframes: [...s].reverse(),
    velocity: -(p.velocity || 0)
  }));
  let F = "idle", L = null, O = null, ct = null;
  R.calculatedDuration === null && i && (R.calculatedDuration = Ds(R));
  const { calculatedDuration: Pt } = R;
  let q = 1 / 0, G = 1 / 0;
  Pt !== null && (q = Pt + o, G = q * (i + 1) - o);
  let B = 0;
  const st = (_) => {
    if (O === null)
      return;
    m > 0 && (O = Math.min(O, _)), m < 0 && (O = Math.min(_ - G / m, O)), L !== null ? B = L : B = Math.round(_ - O) * m;
    const Tt = B - e * (m >= 0 ? 1 : -1), ee = m >= 0 ? Tt < 0 : Tt > G;
    B = Math.max(Tt, 0), F === "finished" && L === null && (B = G);
    let be = B, Ce = R;
    if (i) {
      const Et = Math.min(B, G) / q;
      let yt = Math.floor(Et), vt = Et % 1;
      !vt && Et >= 1 && (vt = 1), vt === 1 && yt--, yt = Math.min(yt, i + 1), !!(yt % 2) && (a === "reverse" ? (vt = 1 - vt, o && (vt -= o / q)) : a === "mirror" && (Ce = X)), be = Vt(0, 1, vt) * q;
    }
    const gt = ee ? { done: !1, value: s[0] } : Ce.next(be);
    T && (gt.value = T(gt.value));
    let { done: Xt } = gt;
    !ee && Pt !== null && (Xt = m >= 0 ? B >= G : B <= 0);
    const It = L === null && (F === "finished" || F === "running" && Xt);
    return f && f(gt.value), It && St(), gt;
  }, U = () => {
    w && w.stop(), w = void 0;
  }, ut = () => {
    F = "idle", U(), y(), P(), O = ct = null;
  }, St = () => {
    F = "finished", u && u(), U(), y();
  }, mt = () => {
    if (g)
      return;
    w || (w = n(st));
    const _ = w.now();
    l && l(), L !== null ? O = _ - L : (!O || F === "finished") && (O = _), F === "finished" && P(), ct = O, L = null, F = "running", w.start();
  };
  t && mt();
  const te = {
    then(_, Tt) {
      return C.then(_, Tt);
    },
    get time() {
      return bt(B);
    },
    set time(_) {
      _ = Rt(_), B = _, L !== null || !w || m === 0 ? L = _ : O = w.now() - _ / m;
    },
    get duration() {
      const _ = R.calculatedDuration === null ? Ds(R) : R.calculatedDuration;
      return bt(_);
    },
    get speed() {
      return m;
    },
    set speed(_) {
      _ === m || !w || (m = _, te.time = bt(B));
    },
    get state() {
      return F;
    },
    play: mt,
    pause: () => {
      F = "paused", L = B;
    },
    stop: () => {
      g = !0, F !== "idle" && (F = "idle", c && c(), ut());
    },
    cancel: () => {
      ct !== null && st(ct), ut();
    },
    complete: () => {
      F = "finished";
    },
    sample: (_) => (O = 0, st(_))
  };
  return te;
}
function Ul(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const Zl = Ul(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Hl = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), Ae = 10, Gl = 2e4, zl = (t, e) => e.type === "spring" || t === "backgroundColor" || !eo(e.ease);
function Kl(t, e, { onUpdate: n, onComplete: s, ...r }) {
  if (!(Zl() && Hl.has(e) && !r.repeatDelay && r.repeatType !== "mirror" && r.damping !== 0 && r.type !== "inertia"))
    return !1;
  let o = !1, a, l, c = !1;
  const u = () => {
    l = new Promise((x) => {
      a = x;
    });
  };
  u();
  let { keyframes: f, duration: p = 300, ease: m, times: g } = r;
  if (zl(e, r)) {
    const x = Be({
      ...r,
      repeat: 0,
      delay: 0
    });
    let T = { done: !1, value: f[0] };
    const R = [];
    let X = 0;
    for (; !T.done && X < Gl; )
      T = x.sample(X), R.push(T.value), X += Ae;
    g = void 0, f = R, p = X - Ae, m = "linear";
  }
  const y = il(t.owner.current, e, f, {
    ...r,
    duration: p,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: m,
    times: g
  }), C = () => {
    c = !1, y.cancel();
  }, P = () => {
    c = !0, $.update(C), a(), u();
  };
  return y.onfinish = () => {
    c || (t.set(al(f, r)), s && s(), P());
  }, {
    then(x, T) {
      return l.then(x, T);
    },
    attachTimeline(x) {
      return y.timeline = x, y.onfinish = null, I;
    },
    get time() {
      return bt(y.currentTime || 0);
    },
    set time(x) {
      y.currentTime = Rt(x);
    },
    get speed() {
      return y.playbackRate;
    },
    set speed(x) {
      y.playbackRate = x;
    },
    get duration() {
      return bt(p);
    },
    play: () => {
      o || (y.play(), Ct(C));
    },
    pause: () => y.pause(),
    stop: () => {
      if (o = !0, y.playState === "idle")
        return;
      const { currentTime: x } = y;
      if (x) {
        const T = Be({
          ...r,
          autoplay: !1
        });
        t.setWithVelocity(T.sample(x - Ae).value, T.sample(x).value, Ae);
      }
      P();
    },
    complete: () => {
      c || y.finish();
    },
    cancel: P
  };
}
function Yl({ keyframes: t, delay: e, onUpdate: n, onComplete: s }) {
  const r = () => (n && n(t[t.length - 1]), s && s(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: I,
    pause: I,
    stop: I,
    then: (i) => (i(), Promise.resolve()),
    cancel: I,
    complete: I
  });
  return e ? Be({
    keyframes: [0, 1],
    duration: 0,
    delay: e,
    onComplete: r
  }) : r();
}
const ql = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Jl = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Ql = {
  type: "keyframes",
  duration: 0.8
}, tc = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, ec = (t, { keyframes: e }) => e.length > 2 ? Ql : Bt.has(t) ? t.startsWith("scale") ? Jl(e[1]) : ql : tc, bn = (t, e) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Lt.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url(")), nc = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function sc(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [s] = n.match(Ge) || [];
  if (!s)
    return t;
  const r = n.replace(s, "");
  let i = nc.has(e) ? 1 : 0;
  return s !== n && (i *= 100), e + "(" + i + r + ")";
}
const rc = /([a-z-]*)\(.*?\)/g, Cn = {
  ...Lt,
  getAnimatableNone: (t) => {
    const e = t.match(rc);
    return e ? e.map(sc).join(" ") : t;
  }
}, oc = {
  ...Br,
  // Color props
  color: Y,
  backgroundColor: Y,
  outlineColor: Y,
  fill: Y,
  stroke: Y,
  // Border props
  borderColor: Y,
  borderTopColor: Y,
  borderRightColor: Y,
  borderBottomColor: Y,
  borderLeftColor: Y,
  filter: Cn,
  WebkitFilter: Cn
}, Zn = (t) => oc[t];
function Mo(t, e) {
  let n = Zn(t);
  return n !== Cn && (n = Lt), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const jo = (t) => /^0[^.\s]+$/.test(t);
function ic(t) {
  if (typeof t == "number")
    return t === 0;
  if (t !== null)
    return t === "none" || t === "0" || jo(t);
}
function ac(t, e, n, s) {
  const r = bn(e, n);
  let i;
  Array.isArray(n) ? i = [...n] : i = [null, n];
  const o = s.from !== void 0 ? s.from : t.get();
  let a;
  const l = [];
  for (let c = 0; c < i.length; c++)
    i[c] === null && (i[c] = c === 0 ? o : i[c - 1]), ic(i[c]) && l.push(c), typeof i[c] == "string" && i[c] !== "none" && i[c] !== "0" && (a = i[c]);
  if (r && l.length && a)
    for (let c = 0; c < l.length; c++) {
      const u = l[c];
      i[u] = Mo(e, a);
    }
  return i;
}
function lc({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: r, repeat: i, repeatType: o, repeatDelay: a, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
function Hn(t, e) {
  return t[e] || t.default || t;
}
const cc = {
  skipAnimations: !1
}, Gn = (t, e, n, s = {}) => (r) => {
  const i = Hn(s, t) || {}, o = i.delay || s.delay || 0;
  let { elapsed: a = 0 } = s;
  a = a - Rt(o);
  const l = ac(e, t, n, i), c = l[0], u = l[l.length - 1], f = bn(t, c), p = bn(t, u);
  xe(f === p, `You are trying to animate ${t} from "${c}" to "${u}". ${c} is not an animatable value - to enable this animation set ${c} to a value animatable to ${u} via the \`style\` property.`);
  let m = {
    keyframes: l,
    velocity: e.getVelocity(),
    ease: "easeOut",
    ...i,
    delay: -a,
    onUpdate: (g) => {
      e.set(g), i.onUpdate && i.onUpdate(g);
    },
    onComplete: () => {
      r(), i.onComplete && i.onComplete();
    }
  };
  if (lc(i) || (m = {
    ...m,
    ...ec(t, m)
  }), m.duration && (m.duration = Rt(m.duration)), m.repeatDelay && (m.repeatDelay = Rt(m.repeatDelay)), !f || !p || ol.current || i.type === !1 || cc.skipAnimations)
    return Yl(m);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !s.isHandoff && e.owner && e.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !e.owner.getProps().onUpdate
  ) {
    const g = Kl(e, t, m);
    if (g)
      return g;
  }
  return Be(m);
};
function Ne(t) {
  return !!(tt(t) && t.add);
}
const Ao = (t) => /^\-?\d*\.?\d+$/.test(t);
function zn(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Kn(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class Yn {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return zn(this.subscriptions, e), () => Kn(this.subscriptions, e);
  }
  notify(e, n, s) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](e, n, s);
      else
        for (let i = 0; i < r; i++) {
          const o = this.subscriptions[i];
          o && o(e, n, s);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const _s = /* @__PURE__ */ new Set();
function qn(t, e, n) {
  t || _s.has(e) || (console.warn(e), _s.add(e));
}
const uc = (t) => !isNaN(parseFloat(t));
class fc {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (s, r = !0) => {
      this.prev = this.current, this.current = s;
      const { delta: i, timestamp: o } = z;
      this.lastUpdated !== o && (this.timeDelta = i, this.lastUpdated = o, $.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), r && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => $.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: s }) => {
      s !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = uc(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && qn(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Yn());
    const s = this.events[e].add(n);
    return e === "change" ? () => {
      s(), $.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, s) {
    this.set(n), this.prev = e, this.timeDelta = s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e) {
    this.updateAndNotify(e), this.prev = e, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      Po(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function qt(t, e) {
  return new fc(t, e);
}
const Ro = (t) => (e) => e.test(t), hc = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Vo = [Nt, M, dt, Mt, wa, xa, hc], oe = (t) => Vo.find(Ro(t)), dc = [...Vo, Y, Lt], pc = (t) => dc.find(Ro(t));
function mc(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, qt(n));
}
function gc(t, e) {
  const n = Ke(t, e);
  let { transitionEnd: s = {}, transition: r = {}, ...i } = n ? t.makeTargetAnimatable(n, !1) : {};
  i = { ...i, ...s };
  for (const o in i) {
    const a = _a(i[o]);
    mc(t, o, a);
  }
}
function yc(t, e, n) {
  var s, r;
  const i = Object.keys(e).filter((a) => !t.hasValue(a)), o = i.length;
  if (o)
    for (let a = 0; a < o; a++) {
      const l = i[a], c = e[l];
      let u = null;
      Array.isArray(c) && (u = c[0]), u === null && (u = (r = (s = n[l]) !== null && s !== void 0 ? s : t.readValue(l)) !== null && r !== void 0 ? r : e[l]), u != null && (typeof u == "string" && (Ao(u) || jo(u)) ? u = parseFloat(u) : !pc(u) && Lt.test(c) && (u = Mo(l, c)), t.addValue(l, qt(u, { owner: t })), n[l] === void 0 && (n[l] = u), u !== null && t.setBaseTarget(l, u));
    }
}
function vc(t, e) {
  return e ? (e[t] || e.default || e).from : void 0;
}
function xc(t, e, n) {
  const s = {};
  for (const r in t) {
    const i = vc(r, e);
    if (i !== void 0)
      s[r] = i;
    else {
      const o = n.getValue(r);
      o && (s[r] = o.get());
    }
  }
  return s;
}
function wc({ protectedKeys: t, needsAnimating: e }, n) {
  const s = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, s;
}
function bc(t, e) {
  const n = t.get();
  if (Array.isArray(e)) {
    for (let s = 0; s < e.length; s++)
      if (e[s] !== n)
        return !0;
  } else
    return n !== e;
}
function Lo(t, e, { delay: n = 0, transitionOverride: s, type: r } = {}) {
  let { transition: i = t.getDefaultTransition(), transitionEnd: o, ...a } = t.makeTargetAnimatable(e);
  const l = t.getValue("willChange");
  s && (i = s);
  const c = [], u = r && t.animationState && t.animationState.getState()[r];
  for (const f in a) {
    const p = t.getValue(f), m = a[f];
    if (!p || m === void 0 || u && wc(u, f))
      continue;
    const g = {
      delay: n,
      elapsed: 0,
      ...Hn(i || {}, f)
    };
    if (window.HandoffAppearAnimations) {
      const P = t.getProps()[Lr];
      if (P) {
        const w = window.HandoffAppearAnimations(P, f, p, $);
        w !== null && (g.elapsed = w, g.isHandoff = !0);
      }
    }
    let y = !g.isHandoff && !bc(p, m);
    if (g.type === "spring" && (p.getVelocity() || g.velocity) && (y = !1), p.animation && (y = !1), y)
      continue;
    p.start(Gn(f, p, m, t.shouldReduceMotion && Bt.has(f) ? { type: !1 } : g));
    const C = p.animation;
    Ne(l) && (l.add(f), C.then(() => l.remove(f))), c.push(C);
  }
  return o && Promise.all(c).then(() => {
    o && gc(t, o);
  }), c;
}
function Pn(t, e, n = {}) {
  const s = Ke(t, e, n.custom);
  let { transition: r = t.getDefaultTransition() || {} } = s || {};
  n.transitionOverride && (r = n.transitionOverride);
  const i = s ? () => Promise.all(Lo(t, s, n)) : () => Promise.resolve(), o = t.variantChildren && t.variantChildren.size ? (l = 0) => {
    const { delayChildren: c = 0, staggerChildren: u, staggerDirection: f } = r;
    return Cc(t, e, c + l, u, f, n);
  } : () => Promise.resolve(), { when: a } = r;
  if (a) {
    const [l, c] = a === "beforeChildren" ? [i, o] : [o, i];
    return l().then(() => c());
  } else
    return Promise.all([i(), o(n.delay)]);
}
function Cc(t, e, n = 0, s = 0, r = 1, i) {
  const o = [], a = (t.variantChildren.size - 1) * s, l = r === 1 ? (c = 0) => c * s : (c = 0) => a - c * s;
  return Array.from(t.variantChildren).sort(Pc).forEach((c, u) => {
    c.notify("AnimationStart", e), o.push(Pn(c, e, {
      ...i,
      delay: n + l(u)
    }).then(() => c.notify("AnimationComplete", e)));
  }), Promise.all(o);
}
function Pc(t, e) {
  return t.sortNodePosition(e);
}
function Sc(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let s;
  if (Array.isArray(e)) {
    const r = e.map((i) => Pn(t, i, n));
    s = Promise.all(r);
  } else if (typeof e == "string")
    s = Pn(t, e, n);
  else {
    const r = typeof e == "function" ? Ke(t, e, n.custom) : e;
    s = Promise.all(Lo(t, r, n));
  }
  return s.then(() => t.notify("AnimationComplete", e));
}
const Tc = [...En].reverse(), Mc = En.length;
function jc(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: s }) => Sc(t, n, s)));
}
function Ac(t) {
  let e = jc(t);
  const n = Vc();
  let s = !0;
  const r = (l, c) => {
    const u = Ke(t, c);
    if (u) {
      const { transition: f, transitionEnd: p, ...m } = u;
      l = { ...l, ...m, ...p };
    }
    return l;
  };
  function i(l) {
    e = l(t);
  }
  function o(l, c) {
    const u = t.getProps(), f = t.getVariantContext(!0) || {}, p = [], m = /* @__PURE__ */ new Set();
    let g = {}, y = 1 / 0;
    for (let P = 0; P < Mc; P++) {
      const w = Tc[P], x = n[w], T = u[w] !== void 0 ? u[w] : f[w], R = de(T), X = w === c ? x.isActive : null;
      X === !1 && (y = P);
      let F = T === f[w] && T !== u[w] && R;
      if (F && s && t.manuallyAnimateOnMount && (F = !1), x.protectedKeys = { ...g }, // If it isn't active and hasn't *just* been set as inactive
      !x.isActive && X === null || // If we didn't and don't have any defined prop for this animation type
      !T && !x.prevProp || // Or if the prop doesn't define an animation
      Ze(T) || typeof T == "boolean")
        continue;
      let O = Rc(x.prevProp, T) || // If we're making this variant active, we want to always make it active
      w === c && x.isActive && !F && R || // If we removed a higher-priority variant (i is in reverse order)
      P > y && R, ct = !1;
      const Pt = Array.isArray(T) ? T : [T];
      let q = Pt.reduce(r, {});
      X === !1 && (q = {});
      const { prevResolvedValues: G = {} } = x, B = {
        ...G,
        ...q
      }, st = (U) => {
        O = !0, m.has(U) && (ct = !0, m.delete(U)), x.needsAnimating[U] = !0;
      };
      for (const U in B) {
        const ut = q[U], St = G[U];
        if (g.hasOwnProperty(U))
          continue;
        let mt = !1;
        Fe(ut) && Fe(St) ? mt = !Qr(ut, St) : mt = ut !== St, mt ? ut !== void 0 ? st(U) : m.add(U) : ut !== void 0 && m.has(U) ? st(U) : x.protectedKeys[U] = !0;
      }
      x.prevProp = T, x.prevResolvedValues = q, x.isActive && (g = { ...g, ...q }), s && t.blockInitialAnimation && (O = !1), O && (!F || ct) && p.push(...Pt.map((U) => ({
        animation: U,
        options: { type: w, ...l }
      })));
    }
    if (m.size) {
      const P = {};
      m.forEach((w) => {
        const x = t.getBaseTarget(w);
        x !== void 0 && (P[w] = x);
      }), p.push({ animation: P });
    }
    let C = !!p.length;
    return s && (u.initial === !1 || u.initial === u.animate) && !t.manuallyAnimateOnMount && (C = !1), s = !1, C ? e(p) : Promise.resolve();
  }
  function a(l, c, u) {
    var f;
    if (n[l].isActive === c)
      return Promise.resolve();
    (f = t.variantChildren) === null || f === void 0 || f.forEach((m) => {
      var g;
      return (g = m.animationState) === null || g === void 0 ? void 0 : g.setActive(l, c);
    }), n[l].isActive = c;
    const p = o(u, l);
    for (const m in n)
      n[m].protectedKeys = {};
    return p;
  }
  return {
    animateChanges: o,
    setActive: a,
    setAnimateFunction: i,
    getState: () => n
  };
}
function Rc(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !Qr(e, t) : !1;
}
function _t(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Vc() {
  return {
    animate: _t(!0),
    whileInView: _t(),
    whileHover: _t(),
    whileTap: _t(),
    whileDrag: _t(),
    whileFocus: _t(),
    exit: _t()
  };
}
class Lc extends kt {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = Ac(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    this.unmount(), Ze(e) && (this.unmount = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let kc = 0;
class Ec extends kt {
  constructor() {
    super(...arguments), this.id = kc++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n, custom: s } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const i = this.node.animationState.setActive("exit", !e, { custom: s ?? this.node.getProps().custom });
    n && !e && i.then(() => n(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const Dc = {
  animation: {
    Feature: Lc
  },
  exit: {
    Feature: Ec
  }
}, Fs = (t, e) => Math.abs(t - e);
function _c(t, e) {
  const n = Fs(t.x, e.x), s = Fs(t.y, e.y);
  return Math.sqrt(n ** 2 + s ** 2);
}
class ko {
  constructor(e, n, { transformPagePoint: s, contextWindow: r, dragSnapToOrigin: i = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = fn(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, m = _c(f.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !m)
        return;
      const { point: g } = f, { timestamp: y } = z;
      this.history.push({ ...g, timestamp: y });
      const { onStart: C, onMove: P } = this.handlers;
      p || (C && C(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), P && P(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, p) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = un(p, this.transformPagePoint), $.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, p) => {
      this.end();
      const { onEnd: m, onSessionEnd: g, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const C = fn(f.type === "pointercancel" ? this.lastMoveEventInfo : un(p, this.transformPagePoint), this.history);
      this.startEvent && m && m(f, C), g && g(f, C);
    }, !zr(e))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = s, this.contextWindow = r || window;
    const o = ze(e), a = un(o, this.transformPagePoint), { point: l } = a, { timestamp: c } = z;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: u } = n;
    u && u(e, fn(a, this.history)), this.removeListeners = At(wt(this.contextWindow, "pointermove", this.handlePointerMove), wt(this.contextWindow, "pointerup", this.handlePointerUp), wt(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), Ct(this.updatePoint);
  }
}
function un(t, e) {
  return e ? { point: e(t.point) } : t;
}
function Os(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function fn({ point: t }, e) {
  return {
    point: t,
    delta: Os(t, Eo(e)),
    offset: Os(t, Fc(e)),
    velocity: Oc(e, 0.1)
  };
}
function Fc(t) {
  return t[0];
}
function Eo(t) {
  return t[t.length - 1];
}
function Oc(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, s = null;
  const r = Eo(t);
  for (; n >= 0 && (s = t[n], !(r.timestamp - s.timestamp > Rt(e))); )
    n--;
  if (!s)
    return { x: 0, y: 0 };
  const i = bt(r.timestamp - s.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (r.x - s.x) / i,
    y: (r.y - s.y) / i
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function et(t) {
  return t.max - t.min;
}
function Sn(t, e = 0, n = 0.01) {
  return Math.abs(t - e) <= n;
}
function $s(t, e, n, s = 0.5) {
  t.origin = s, t.originPoint = N(e.min, e.max, t.origin), t.scale = et(n) / et(e), (Sn(t.scale, 1, 1e-4) || isNaN(t.scale)) && (t.scale = 1), t.translate = N(n.min, n.max, t.origin) - t.originPoint, (Sn(t.translate) || isNaN(t.translate)) && (t.translate = 0);
}
function fe(t, e, n, s) {
  $s(t.x, e.x, n.x, s ? s.originX : void 0), $s(t.y, e.y, n.y, s ? s.originY : void 0);
}
function Bs(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + et(e);
}
function $c(t, e, n) {
  Bs(t.x, e.x, n.x), Bs(t.y, e.y, n.y);
}
function Ns(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + et(e);
}
function he(t, e, n) {
  Ns(t.x, e.x, n.x), Ns(t.y, e.y, n.y);
}
function Bc(t, { min: e, max: n }, s) {
  return e !== void 0 && t < e ? t = s ? N(e, t, s.min) : Math.max(t, e) : n !== void 0 && t > n && (t = s ? N(n, t, s.max) : Math.min(t, n)), t;
}
function Xs(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Nc(t, { top: e, left: n, bottom: s, right: r }) {
  return {
    x: Xs(t.x, n, r),
    y: Xs(t.y, e, s)
  };
}
function Is(t, e) {
  let n = e.min - t.min, s = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, s] = [s, n]), { min: n, max: s };
}
function Xc(t, e) {
  return {
    x: Is(t.x, e.x),
    y: Is(t.y, e.y)
  };
}
function Ic(t, e) {
  let n = 0.5;
  const s = et(t), r = et(e);
  return r > s ? n = me(e.min, e.max - s, t.min) : s > r && (n = me(t.min, t.max - r, e.min)), Vt(0, 1, n);
}
function Wc(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const Tn = 0.35;
function Uc(t = Tn) {
  return t === !1 ? t = 0 : t === !0 && (t = Tn), {
    x: Ws(t, "left", "right"),
    y: Ws(t, "top", "bottom")
  };
}
function Ws(t, e, n) {
  return {
    min: Us(t, e),
    max: Us(t, n)
  };
}
function Us(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const Zs = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), zt = () => ({
  x: Zs(),
  y: Zs()
}), Hs = () => ({ min: 0, max: 0 }), H = () => ({
  x: Hs(),
  y: Hs()
});
function it(t) {
  return [t("x"), t("y")];
}
function Do({ top: t, left: e, right: n, bottom: s }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: s }
  };
}
function Zc({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function Hc(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), s = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: s.y,
    right: s.x
  };
}
function hn(t) {
  return t === void 0 || t === 1;
}
function Mn({ scale: t, scaleX: e, scaleY: n }) {
  return !hn(t) || !hn(e) || !hn(n);
}
function Ft(t) {
  return Mn(t) || _o(t) || t.z || t.rotate || t.rotateX || t.rotateY;
}
function _o(t) {
  return Gs(t.x) || Gs(t.y);
}
function Gs(t) {
  return t && t !== "0%";
}
function Xe(t, e, n) {
  const s = t - n, r = e * s;
  return n + r;
}
function zs(t, e, n, s, r) {
  return r !== void 0 && (t = Xe(t, r, s)), Xe(t, n, s) + e;
}
function jn(t, e = 0, n = 1, s, r) {
  t.min = zs(t.min, e, n, s, r), t.max = zs(t.max, e, n, s, r);
}
function Fo(t, { x: e, y: n }) {
  jn(t.x, e.translate, e.scale, e.originPoint), jn(t.y, n.translate, n.scale, n.originPoint);
}
function Gc(t, e, n, s = !1) {
  const r = n.length;
  if (!r)
    return;
  e.x = e.y = 1;
  let i, o;
  for (let a = 0; a < r; a++) {
    i = n[a], o = i.projectionDelta;
    const l = i.instance;
    l && l.style && l.style.display === "contents" || (s && i.options.layoutScroll && i.scroll && i !== i.root && Kt(t, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, Fo(t, o)), s && Ft(i.latestValues) && Kt(t, i.latestValues));
  }
  e.x = Ks(e.x), e.y = Ks(e.y);
}
function Ks(t) {
  return Number.isInteger(t) || t > 1.0000000000001 || t < 0.999999999999 ? t : 1;
}
function jt(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function Ys(t, e, [n, s, r]) {
  const i = e[r] !== void 0 ? e[r] : 0.5, o = N(t.min, t.max, i);
  jn(t, e[n], e[s], o, e.scale);
}
const zc = ["x", "scaleX", "originX"], Kc = ["y", "scaleY", "originY"];
function Kt(t, e) {
  Ys(t.x, e, zc), Ys(t.y, e, Kc);
}
function Oo(t, e) {
  return Do(Hc(t.getBoundingClientRect(), e));
}
function Yc(t, e, n) {
  const s = Oo(t, n), { scroll: r } = e;
  return r && (jt(s.x, r.offset.x), jt(s.y, r.offset.y)), s;
}
const $o = ({ current: t }) => t ? t.ownerDocument.defaultView : null, qc = /* @__PURE__ */ new WeakMap();
class Jc {
  constructor(e) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = H(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: s } = this.visualElement;
    if (s && s.isPresent === !1)
      return;
    const r = (u) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(ze(u, "page").point);
    }, i = (u, f) => {
      const { drag: p, dragPropagation: m, onDragStart: g } = this.getProps();
      if (p && !m && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = Yr(p), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), it((C) => {
        let P = this.getAxisMotionValue(C).get() || 0;
        if (dt.test(P)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const x = w.layout.layoutBox[C];
            x && (P = et(x) * (parseFloat(P) / 100));
          }
        }
        this.originPoint[C] = P;
      }), g && $.update(() => g(u, f), !1, !0);
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, o = (u, f) => {
      const { dragPropagation: p, dragDirectionLock: m, onDirectionLock: g, onDrag: y } = this.getProps();
      if (!p && !this.openGlobalLock)
        return;
      const { offset: C } = f;
      if (m && this.currentDirection === null) {
        this.currentDirection = Qc(C), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, C), this.updateAxis("y", f.point, C), this.visualElement.render(), y && y(u, f);
    }, a = (u, f) => this.stop(u, f), l = () => it((u) => {
      var f;
      return this.getAnimationState(u) === "paused" && ((f = this.getAxisMotionValue(u).animation) === null || f === void 0 ? void 0 : f.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new ko(e, {
      onSessionStart: r,
      onStart: i,
      onMove: o,
      onSessionEnd: a,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: $o(this.visualElement)
    });
  }
  stop(e, n) {
    const s = this.isDragging;
    if (this.cancel(), !s)
      return;
    const { velocity: r } = n;
    this.startAnimation(r);
    const { onDragEnd: i } = this.getProps();
    i && $.update(() => i(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: s } = this.getProps();
    !s && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, s) {
    const { drag: r } = this.getProps();
    if (!s || !Re(e, r, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + s[e];
    this.constraints && this.constraints[e] && (o = Bc(o, this.constraints[e], this.elastic[e])), i.set(o);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: n, dragElastic: s } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, i = this.constraints;
    n && Ht(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && r ? this.constraints = Nc(r.layoutBox, n) : this.constraints = !1, this.elastic = Uc(s), i !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && it((o) => {
      this.getAxisMotionValue(o) && (this.constraints[o] = Wc(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !Ht(e))
      return !1;
    const s = e.current;
    ft(s !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: r } = this.visualElement;
    if (!r || !r.layout)
      return !1;
    const i = Yc(s, r.root, this.visualElement.getTransformPagePoint());
    let o = Xc(r.layout.layoutBox, i);
    if (n) {
      const a = n(Zc(o));
      this.hasMutatedConstraints = !!a, a && (o = Do(a));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: s, dragElastic: r, dragTransition: i, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = it((u) => {
      if (!Re(u, n, this.currentDirection))
        return;
      let f = l && l[u] || {};
      o && (f = { min: 0, max: 0 });
      const p = r ? 200 : 1e6, m = r ? 40 : 1e7, g = {
        type: "inertia",
        velocity: s ? e[u] : 0,
        bounceStiffness: p,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...f
      };
      return this.startAxisValueAnimation(u, g);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(e, n) {
    const s = this.getAxisMotionValue(e);
    return s.start(Gn(e, s, 0, n));
  }
  stopAnimation() {
    it((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    it((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = "_drag" + e.toUpperCase(), s = this.visualElement.getProps(), r = s[n];
    return r || this.visualElement.getValue(e, (s.initial ? s.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    it((n) => {
      const { drag: s } = this.getProps();
      if (!Re(n, s, this.currentDirection))
        return;
      const { projection: r } = this.visualElement, i = this.getAxisMotionValue(n);
      if (r && r.layout) {
        const { min: o, max: a } = r.layout.layoutBox[n];
        i.set(e[n] - N(o, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: s } = this.visualElement;
    if (!Ht(n) || !s || !this.constraints)
      return;
    this.stopAnimation();
    const r = { x: 0, y: 0 };
    it((o) => {
      const a = this.getAxisMotionValue(o);
      if (a) {
        const l = a.get();
        r[o] = Ic({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", s.root && s.root.updateScroll(), s.updateLayout(), this.resolveConstraints(), it((o) => {
      if (!Re(o, e, null))
        return;
      const a = this.getAxisMotionValue(o), { min: l, max: c } = this.constraints[o];
      a.set(N(l, c, r[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    qc.set(this.visualElement, this);
    const e = this.visualElement.current, n = wt(e, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), s = () => {
      const { dragConstraints: l } = this.getProps();
      Ht(l) && (this.constraints = this.resolveRefConstraints());
    }, { projection: r } = this.visualElement, i = r.addEventListener("measure", s);
    r && !r.layout && (r.root && r.root.updateScroll(), r.updateLayout()), s();
    const o = xt(window, "resize", () => this.scalePositionWithinConstraints()), a = r.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (it((u) => {
        const f = this.getAxisMotionValue(u);
        f && (this.originPoint[u] += l[u].translate, f.set(f.get() + l[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), i(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: s = !1, dragPropagation: r = !1, dragConstraints: i = !1, dragElastic: o = Tn, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: s,
      dragPropagation: r,
      dragConstraints: i,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function Re(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function Qc(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class tu extends kt {
  constructor(e) {
    super(e), this.removeGroupControls = I, this.removeListeners = I, this.controls = new Jc(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || I;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const qs = (t) => (e, n) => {
  t && $.update(() => t(e, n));
};
class eu extends kt {
  constructor() {
    super(...arguments), this.removePointerDownListener = I;
  }
  onPointerDown(e) {
    this.session = new ko(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: $o(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: s, onPanEnd: r } = this.node.getProps();
    return {
      onSessionStart: qs(e),
      onStart: qs(n),
      onMove: s,
      onEnd: (i, o) => {
        delete this.session, r && $.update(() => r(i, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = wt(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function nu() {
  const t = Q(Ln);
  if (t === null)
    return [!0, null];
  const { isPresent: e, onExitComplete: n, register: s } = t, r = zi();
  return Vn(() => s(r), []), !e && n ? [!1, () => n && n(r)] : [!0];
}
const Ee = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Js(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const ie = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (M.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = Js(t, e.target.x), s = Js(t, e.target.y);
    return `${n}% ${s}%`;
  }
}, su = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const s = t, r = Lt.parse(t);
    if (r.length > 5)
      return s;
    const i = Lt.createTransformer(t), o = typeof r[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    r[0 + o] /= a, r[1 + o] /= l;
    const c = N(a, l, 0.5);
    return typeof r[2 + o] == "number" && (r[2 + o] /= c), typeof r[3 + o] == "number" && (r[3 + o] /= c), i(r);
  }
};
class ru extends Ie.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s, layoutId: r } = this.props, { projection: i } = e;
    ha(ou), i && (n.group && n.group.add(i), s && s.register && r && s.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), Ee.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: s, drag: r, isPresent: i } = this.props, o = s.projection;
    return o && (o.isPresent = i, r || e.layoutDependency !== n || n === void 0 ? o.willUpdate() : this.safeToRemove(), e.isPresent !== i && (i ? o.promote() : o.relegate() || $.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), queueMicrotask(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s } = this.props, { projection: r } = e;
    r && (r.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(r), s && s.deregister && s.deregister(r));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function Bo(t) {
  const [e, n] = nu(), s = Q(Er);
  return Ie.createElement(ru, { ...t, layoutGroup: s, switchLayoutGroup: Q(Dr), isPresent: e, safeToRemove: n });
}
const ou = {
  borderRadius: {
    ...ie,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: ie,
  borderTopRightRadius: ie,
  borderBottomLeftRadius: ie,
  borderBottomRightRadius: ie,
  boxShadow: su
}, No = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], iu = No.length, Qs = (t) => typeof t == "string" ? parseFloat(t) : t, tr = (t) => typeof t == "number" || M.test(t);
function au(t, e, n, s, r, i) {
  r ? (t.opacity = N(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    lu(s)
  ), t.opacityExit = N(e.opacity !== void 0 ? e.opacity : 1, 0, cu(s))) : i && (t.opacity = N(e.opacity !== void 0 ? e.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, s));
  for (let o = 0; o < iu; o++) {
    const a = `border${No[o]}Radius`;
    let l = er(e, a), c = er(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || tr(l) === tr(c) ? (t[a] = Math.max(N(Qs(l), Qs(c), s), 0), (dt.test(c) || dt.test(l)) && (t[a] += "%")) : t[a] = c;
  }
  (e.rotate || n.rotate) && (t.rotate = N(e.rotate || 0, n.rotate || 0, s));
}
function er(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const lu = Xo(0, 0.5, lo), cu = Xo(0.5, 0.95, I);
function Xo(t, e, n) {
  return (s) => s < t ? 0 : s > e ? 1 : n(me(t, e, s));
}
function nr(t, e) {
  t.min = e.min, t.max = e.max;
}
function ot(t, e) {
  nr(t.x, e.x), nr(t.y, e.y);
}
function sr(t, e, n, s, r) {
  return t -= e, t = Xe(t, 1 / n, s), r !== void 0 && (t = Xe(t, 1 / r, s)), t;
}
function uu(t, e = 0, n = 1, s = 0.5, r, i = t, o = t) {
  if (dt.test(e) && (e = parseFloat(e), e = N(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let a = N(i.min, i.max, s);
  t === i && (a -= e), t.min = sr(t.min, e, n, a, r), t.max = sr(t.max, e, n, a, r);
}
function rr(t, e, [n, s, r], i, o) {
  uu(t, e[n], e[s], e[r], e.scale, i, o);
}
const fu = ["x", "scaleX", "originX"], hu = ["y", "scaleY", "originY"];
function or(t, e, n, s) {
  rr(t.x, e, fu, n ? n.x : void 0, s ? s.x : void 0), rr(t.y, e, hu, n ? n.y : void 0, s ? s.y : void 0);
}
function ir(t) {
  return t.translate === 0 && t.scale === 1;
}
function Io(t) {
  return ir(t.x) && ir(t.y);
}
function du(t, e) {
  return t.x.min === e.x.min && t.x.max === e.x.max && t.y.min === e.y.min && t.y.max === e.y.max;
}
function Wo(t, e) {
  return Math.round(t.x.min) === Math.round(e.x.min) && Math.round(t.x.max) === Math.round(e.x.max) && Math.round(t.y.min) === Math.round(e.y.min) && Math.round(t.y.max) === Math.round(e.y.max);
}
function ar(t) {
  return et(t.x) / et(t.y);
}
class pu {
  constructor() {
    this.members = [];
  }
  add(e) {
    zn(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Kn(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((r) => e === r);
    if (n === 0)
      return !1;
    let s;
    for (let r = n; r >= 0; r--) {
      const i = this.members[r];
      if (i.isPresent !== !1) {
        s = i;
        break;
      }
    }
    return s ? (this.promote(s), !0) : !1;
  }
  promote(e, n) {
    const s = this.lead;
    if (e !== s && (this.prevLead = s, this.lead = e, e.show(), s)) {
      s.instance && s.scheduleRender(), e.scheduleRender(), e.resumeFrom = s, n && (e.resumeFrom.preserveOpacity = !0), s.snapshot && (e.snapshot = s.snapshot, e.snapshot.latestValues = s.animationValues || s.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: r } = e.options;
      r === !1 && s.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: s } = e;
      n.onExitComplete && n.onExitComplete(), s && s.options.onExitComplete && s.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function lr(t, e, n) {
  let s = "";
  const r = t.x.translate / e.x, i = t.y.translate / e.y;
  if ((r || i) && (s = `translate3d(${r}px, ${i}px, 0) `), (e.x !== 1 || e.y !== 1) && (s += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { rotate: l, rotateX: c, rotateY: u } = n;
    l && (s += `rotate(${l}deg) `), c && (s += `rotateX(${c}deg) `), u && (s += `rotateY(${u}deg) `);
  }
  const o = t.x.scale * e.x, a = t.y.scale * e.y;
  return (o !== 1 || a !== 1) && (s += `scale(${o}, ${a})`), s || "none";
}
const mu = (t, e) => t.depth - e.depth;
class gu {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    zn(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Kn(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(mu), this.isDirty = !1, this.children.forEach(e);
  }
}
function yu(t, e) {
  const n = performance.now(), s = ({ timestamp: r }) => {
    const i = r - n;
    i >= e && (Ct(s), t(i - e));
  };
  return $.read(s, !0), () => Ct(s);
}
function vu(t) {
  window.MotionDebug && window.MotionDebug.record(t);
}
function xu(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
function wu(t, e, n) {
  const s = tt(t) ? t : qt(t);
  return s.start(Gn("", s, e, n)), s.animation;
}
const cr = ["", "X", "Y", "Z"], bu = { visibility: "hidden" }, ur = 1e3;
let Cu = 0;
const Ot = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function Uo({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: s, resetTransform: r }) {
  return class {
    constructor(o = {}, a = e == null ? void 0 : e()) {
      this.id = Cu++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Ot.totalNodes = Ot.resolvedTargetDeltas = Ot.recalculatedProjection = 0, this.nodes.forEach(Tu), this.nodes.forEach(Vu), this.nodes.forEach(Lu), this.nodes.forEach(Mu), vu(Ot);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new gu());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Yn()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = xu(o), this.instance = o;
      const { layoutId: l, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (c || l) && (this.isLayoutDirty = !0), t) {
        let f;
        const p = () => this.root.updateBlockedByResize = !1;
        t(o, () => {
          this.root.updateBlockedByResize = !0, f && f(), f = yu(p, 250), Ee.hasAnimatedSinceResize && (Ee.hasAnimatedSinceResize = !1, this.nodes.forEach(hr));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && u && (l || c) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: p, hasRelativeTargetChanged: m, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || u.getDefaultTransition() || Fu, { onLayoutAnimationStart: C, onLayoutAnimationComplete: P } = u.getProps(), w = !this.targetLayout || !Wo(this.targetLayout, g) || m, x = !p && m;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || x || p && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(f, x);
          const T = {
            ...Hn(y, "layout"),
            onPlay: C,
            onComplete: P
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (T.delay = 0, T.type = !1), this.startAnimation(T);
        } else
          p || hr(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Ct(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(ku), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(fr);
        return;
      }
      this.isUpdating || this.nodes.forEach(Au), this.isUpdating = !1, this.nodes.forEach(Ru), this.nodes.forEach(Pu), this.nodes.forEach(Su), this.clearAllSnapshots();
      const a = performance.now();
      z.delta = Vt(0, 1e3 / 60, a - z.timestamp), z.timestamp = a, z.isProcessing = !0, nn.update.process(z), nn.preRender.process(z), nn.render.process(z), z.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(ju), this.sharedNodes.forEach(Eu);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, $.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      $.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = H(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && (this.scroll = {
        animationId: this.root.animationId,
        phase: o,
        isRoot: s(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!r)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform, a = this.projectionDelta && !Io(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      o && (a || Ft(this.latestValues) || u) && (r(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return o && (l = this.removeTransform(l)), Ou(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: o } = this.options;
      if (!o)
        return H();
      const a = o.measureViewportBox(), { scroll: l } = this.root;
      return l && (jt(a.x, l.offset.x), jt(a.y, l.offset.y)), a;
    }
    removeElementScroll(o) {
      const a = H();
      ot(a, o);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l], { scroll: u, options: f } = c;
        if (c !== this.root && u && f.layoutScroll) {
          if (u.isRoot) {
            ot(a, o);
            const { scroll: p } = this.root;
            p && (jt(a.x, -p.offset.x), jt(a.y, -p.offset.y));
          }
          jt(a.x, u.offset.x), jt(a.y, u.offset.y);
        }
      }
      return a;
    }
    applyTransform(o, a = !1) {
      const l = H();
      ot(l, o);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !a && u.options.layoutScroll && u.scroll && u !== u.root && Kt(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), Ft(u.latestValues) && Kt(l, u.latestValues);
      }
      return Ft(this.latestValues) && Kt(l, this.latestValues), l;
    }
    removeTransform(o) {
      const a = H();
      ot(a, o);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !Ft(c.latestValues))
          continue;
        Mn(c.latestValues) && c.updateSnapshot();
        const u = H(), f = c.measurePageBox();
        ot(u, f), or(a, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return Ft(this.latestValues) && or(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== z.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var a;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: f, layoutId: p } = this.options;
      if (!(!this.layout || !(f || p))) {
        if (this.resolvedRelativeTargetAt = z.timestamp, !this.targetDelta && !this.relativeTarget) {
          const m = this.getClosestProjectingParent();
          m && m.layout && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = H(), this.relativeTargetOrigin = H(), he(this.relativeTargetOrigin, this.layout.layoutBox, m.layout.layoutBox), ot(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = H(), this.targetWithTransforms = H()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), $c(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : ot(this.target, this.layout.layoutBox), Fo(this.target, this.targetDelta)) : ot(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const m = this.getClosestProjectingParent();
            m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = H(), this.relativeTargetOrigin = H(), he(this.relativeTargetOrigin, this.target, m.target), ot(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Ot.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Mn(this.parent.latestValues) || _o(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var o;
      const a = this.getLead(), l = !!this.resumingFrom || this !== a;
      let c = !0;
      if ((this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === z.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: f } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || f))
        return;
      ot(this.layoutCorrected, this.layout.layoutBox);
      const p = this.treeScale.x, m = this.treeScale.y;
      Gc(this.layoutCorrected, this.treeScale, this.path, l), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox);
      const { target: g } = a;
      if (!g) {
        this.projectionTransform && (this.projectionDelta = zt(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = zt(), this.projectionDeltaWithTransform = zt());
      const y = this.projectionTransform;
      fe(this.projectionDelta, this.layoutCorrected, g, this.latestValues), this.projectionTransform = lr(this.projectionDelta, this.treeScale), (this.projectionTransform !== y || this.treeScale.x !== p || this.treeScale.y !== m) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g)), Ot.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), o) {
        const a = this.getStack();
        a && a.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(o, a = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, f = zt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const p = H(), m = l ? l.source : void 0, g = this.layout ? this.layout.source : void 0, y = m !== g, C = this.getStack(), P = !C || C.members.length <= 1, w = !!(y && !P && this.options.crossfade === !0 && !this.path.some(_u));
      this.animationProgress = 0;
      let x;
      this.mixTargetDelta = (T) => {
        const R = T / 1e3;
        dr(f.x, o.x, R), dr(f.y, o.y, R), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (he(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Du(this.relativeTarget, this.relativeTargetOrigin, p, R), x && du(this.relativeTarget, x) && (this.isProjectionDirty = !1), x || (x = H()), ot(x, this.relativeTarget)), y && (this.animationValues = u, au(u, c, this.latestValues, R, w, P)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = R;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Ct(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = $.update(() => {
        Ee.hasAnimatedSinceResize = !0, this.currentAnimation = wu(0, ur, {
          ...o,
          onUpdate: (a) => {
            this.mixTargetDelta(a), o.onUpdate && o.onUpdate(a);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(ur), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: u } = o;
      if (!(!a || !l || !c)) {
        if (this !== o && this.layout && c && Zo(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || H();
          const f = et(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + f;
          const p = et(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + p;
        }
        ot(a, l), Kt(a, u), fe(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new pu()), this.sharedNodes.get(o).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var o;
      const { layoutId: a } = this.options;
      return a ? ((o = this.getStack()) === null || o === void 0 ? void 0 : o.lead) || this : this;
    }
    getPrevLead() {
      var o;
      const { layoutId: a } = this.options;
      return a ? (o = this.getStack()) === null || o === void 0 ? void 0 : o.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: l } = o;
      if ((l.rotate || l.rotateX || l.rotateY || l.rotateZ) && (a = !0), !a)
        return;
      const c = {};
      for (let u = 0; u < cr.length; u++) {
        const f = "rotate" + cr[u];
        l[f] && (c[f] = l[f], o.setStaticValue(f, 0));
      }
      o.render();
      for (const u in c)
        o.setStaticValue(u, c[u]);
      o.scheduleRender();
    }
    getProjectionStyles(o) {
      var a, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return bu;
      const c = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = ke(o == null ? void 0 : o.pointerEvents) || "", c.transform = u ? u(this.latestValues, "") : "none", c;
      const f = this.getLead();
      if (!this.projectionDelta || !this.layout || !f.target) {
        const y = {};
        return this.options.layoutId && (y.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, y.pointerEvents = ke(o == null ? void 0 : o.pointerEvents) || ""), this.hasProjected && !Ft(this.latestValues) && (y.transform = u ? u({}, "") : "none", this.hasProjected = !1), y;
      }
      const p = f.animationValues || f.latestValues;
      this.applyTransformsToTarget(), c.transform = lr(this.projectionDeltaWithTransform, this.treeScale, p), u && (c.transform = u(p, c.transform));
      const { x: m, y: g } = this.projectionDelta;
      c.transformOrigin = `${m.origin * 100}% ${g.origin * 100}% 0`, f.animationValues ? c.opacity = f === this ? (l = (a = p.opacity) !== null && a !== void 0 ? a : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : p.opacityExit : c.opacity = f === this ? p.opacity !== void 0 ? p.opacity : "" : p.opacityExit !== void 0 ? p.opacityExit : 0;
      for (const y in De) {
        if (p[y] === void 0)
          continue;
        const { correct: C, applyTo: P } = De[y], w = c.transform === "none" ? p[y] : C(p[y], f);
        if (P) {
          const x = P.length;
          for (let T = 0; T < x; T++)
            c[P[T]] = w;
        } else
          c[y] = w;
      }
      return this.options.layoutId && (c.pointerEvents = f === this ? ke(o == null ? void 0 : o.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) === null || a === void 0 ? void 0 : a.stop();
      }), this.root.nodes.forEach(fr), this.root.sharedNodes.clear();
    }
  };
}
function Pu(t) {
  t.updateLayout();
}
function Su(t) {
  var e;
  const n = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && n && t.hasListeners("didUpdate")) {
    const { layoutBox: s, measuredBox: r } = t.layout, { animationType: i } = t.options, o = n.source !== t.layout.source;
    i === "size" ? it((f) => {
      const p = o ? n.measuredBox[f] : n.layoutBox[f], m = et(p);
      p.min = s[f].min, p.max = p.min + m;
    }) : Zo(i, n.layoutBox, s) && it((f) => {
      const p = o ? n.measuredBox[f] : n.layoutBox[f], m = et(s[f]);
      p.max = p.min + m, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[f].max = t.relativeTarget[f].min + m);
    });
    const a = zt();
    fe(a, s, n.layoutBox);
    const l = zt();
    o ? fe(l, t.applyTransform(r, !0), n.measuredBox) : fe(l, s, n.layoutBox);
    const c = !Io(a);
    let u = !1;
    if (!t.resumeFrom) {
      const f = t.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: p, layout: m } = f;
        if (p && m) {
          const g = H();
          he(g, n.layoutBox, p.layoutBox);
          const y = H();
          he(y, s, m.layoutBox), Wo(g, y) || (u = !0), f.options.layoutRoot && (t.relativeTarget = y, t.relativeTargetOrigin = g, t.relativeParent = f);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: s,
      snapshot: n,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: u
    });
  } else if (t.isLead()) {
    const { onExitComplete: s } = t.options;
    s && s();
  }
  t.options.transition = void 0;
}
function Tu(t) {
  Ot.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function Mu(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function ju(t) {
  t.clearSnapshot();
}
function fr(t) {
  t.clearMeasurements();
}
function Au(t) {
  t.isLayoutDirty = !1;
}
function Ru(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function hr(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function Vu(t) {
  t.resolveTargetDelta();
}
function Lu(t) {
  t.calcProjection();
}
function ku(t) {
  t.resetRotation();
}
function Eu(t) {
  t.removeLeadSnapshot();
}
function dr(t, e, n) {
  t.translate = N(e.translate, 0, n), t.scale = N(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function pr(t, e, n, s) {
  t.min = N(e.min, n.min, s), t.max = N(e.max, n.max, s);
}
function Du(t, e, n, s) {
  pr(t.x, e.x, n.x, s), pr(t.y, e.y, n.y, s);
}
function _u(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const Fu = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, mr = (t) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(t), gr = mr("applewebkit/") && !mr("chrome/") ? Math.round : I;
function yr(t) {
  t.min = gr(t.min), t.max = gr(t.max);
}
function Ou(t) {
  yr(t.x), yr(t.y);
}
function Zo(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !Sn(ar(e), ar(n), 0.2);
}
const $u = Uo({
  attachResizeListener: (t, e) => xt(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), dn = {
  current: void 0
}, Ho = Uo({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!dn.current) {
      const t = new $u({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), dn.current = t;
    }
    return dn.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), Bu = {
  pan: {
    Feature: eu
  },
  drag: {
    Feature: tu,
    ProjectionNode: Ho,
    MeasureLayout: Bo
  }
}, Nu = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function Xu(t) {
  const e = Nu.exec(t);
  if (!e)
    return [,];
  const [, n, s] = e;
  return [n, s];
}
const Iu = 4;
function An(t, e, n = 1) {
  ft(n <= Iu, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [s, r] = Xu(t);
  if (!s)
    return;
  const i = window.getComputedStyle(e).getPropertyValue(s);
  if (i) {
    const o = i.trim();
    return Ao(o) ? parseFloat(o) : o;
  } else return yn(r) ? An(r, e, n + 1) : r;
}
function Wu(t, { ...e }, n) {
  const s = t.current;
  if (!(s instanceof Element))
    return { target: e, transitionEnd: n };
  n && (n = { ...n }), t.values.forEach((r) => {
    const i = r.get();
    if (!yn(i))
      return;
    const o = An(i, s);
    o && r.set(o);
  });
  for (const r in e) {
    const i = e[r];
    if (!yn(i))
      continue;
    const o = An(i, s);
    o && (e[r] = o, n || (n = {}), n[r] === void 0 && (n[r] = i));
  }
  return { target: e, transitionEnd: n };
}
const Uu = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), Go = (t) => Uu.has(t), Zu = (t) => Object.keys(t).some(Go), Ve = (t) => t === Nt || t === M, vr = (t, e) => parseFloat(t.split(", ")[e]), xr = (t, e) => (n, { transform: s }) => {
  if (s === "none" || !s)
    return 0;
  const r = s.match(/^matrix3d\((.+)\)$/);
  if (r)
    return vr(r[1], e);
  {
    const i = s.match(/^matrix\((.+)\)$/);
    return i ? vr(i[1], t) : 0;
  }
}, Hu = /* @__PURE__ */ new Set(["x", "y", "z"]), Gu = ge.filter((t) => !Hu.has(t));
function zu(t) {
  const e = [];
  return Gu.forEach((n) => {
    const s = t.getValue(n);
    s !== void 0 && (e.push([n, s.get()]), s.set(n.startsWith("scale") ? 1 : 0));
  }), e.length && t.render(), e;
}
const Jt = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: xr(4, 13),
  y: xr(5, 14)
};
Jt.translateX = Jt.x;
Jt.translateY = Jt.y;
const Ku = (t, e, n) => {
  const s = e.measureViewportBox(), r = e.current, i = getComputedStyle(r), { display: o } = i, a = {};
  o === "none" && e.setStaticValue("display", t.display || "block"), n.forEach((c) => {
    a[c] = Jt[c](s, i);
  }), e.render();
  const l = e.measureViewportBox();
  return n.forEach((c) => {
    const u = e.getValue(c);
    u && u.jump(a[c]), t[c] = Jt[c](l, i);
  }), t;
}, Yu = (t, e, n = {}, s = {}) => {
  e = { ...e }, s = { ...s };
  const r = Object.keys(e).filter(Go);
  let i = [], o = !1;
  const a = [];
  if (r.forEach((l) => {
    const c = t.getValue(l);
    if (!t.hasValue(l))
      return;
    let u = n[l], f = oe(u);
    const p = e[l];
    let m;
    if (Fe(p)) {
      const g = p.length, y = p[0] === null ? 1 : 0;
      u = p[y], f = oe(u);
      for (let C = y; C < g && p[C] !== null; C++)
        m ? ft(oe(p[C]) === m, "All keyframes must be of the same type") : (m = oe(p[C]), ft(m === f || Ve(f) && Ve(m), "Keyframes must be of the same dimension as the current value"));
    } else
      m = oe(p);
    if (f !== m)
      if (Ve(f) && Ve(m)) {
        const g = c.get();
        typeof g == "string" && c.set(parseFloat(g)), typeof p == "string" ? e[l] = parseFloat(p) : Array.isArray(p) && m === M && (e[l] = p.map(parseFloat));
      } else f != null && f.transform && (m != null && m.transform) && (u === 0 || p === 0) ? u === 0 ? c.set(m.transform(u)) : e[l] = f.transform(p) : (o || (i = zu(t), o = !0), a.push(l), s[l] = s[l] !== void 0 ? s[l] : e[l], c.jump(p));
  }), a.length) {
    const l = a.indexOf("height") >= 0 ? window.pageYOffset : null, c = Ku(e, t, a);
    return i.length && i.forEach(([u, f]) => {
      t.getValue(u).set(f);
    }), t.render(), Ue && l !== null && window.scrollTo({ top: l }), { target: c, transitionEnd: s };
  } else
    return { target: e, transitionEnd: s };
};
function qu(t, e, n, s) {
  return Zu(e) ? Yu(t, e, n, s) : { target: e, transitionEnd: s };
}
const Ju = (t, e, n, s) => {
  const r = Wu(t, e, s);
  return e = r.target, s = r.transitionEnd, qu(t, e, n, s);
}, Rn = { current: null }, zo = { current: !1 };
function Qu() {
  if (zo.current = !0, !!Ue)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => Rn.current = t.matches;
      t.addListener(e), e();
    } else
      Rn.current = !1;
}
function tf(t, e, n) {
  const { willChange: s } = e;
  for (const r in e) {
    const i = e[r], o = n[r];
    if (tt(i))
      t.addValue(r, i), Ne(s) && s.add(r), process.env.NODE_ENV === "development" && qn(i.version === "10.18.0", `Attempting to mix Framer Motion versions ${i.version} with 10.18.0 may not work as expected.`);
    else if (tt(o))
      t.addValue(r, qt(i, { owner: t })), Ne(s) && s.remove(r);
    else if (o !== i)
      if (t.hasValue(r)) {
        const a = t.getValue(r);
        !a.hasAnimated && a.set(i);
      } else {
        const a = t.getStaticValue(r);
        t.addValue(r, qt(a !== void 0 ? a : i, { owner: t }));
      }
  }
  for (const r in n)
    e[r] === void 0 && t.removeValue(r);
  return e;
}
const wr = /* @__PURE__ */ new WeakMap(), Ko = Object.keys(pe), ef = Ko.length, br = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], nf = Dn.length;
class sf {
  constructor({ parent: e, props: n, presenceContext: s, reducedMotionConfig: r, visualState: i }, o = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => $.render(this.render, !1, !0);
    const { latestValues: a, renderState: l } = i;
    this.latestValues = a, this.baseTarget = { ...a }, this.initialValues = n.initial ? { ...a } : {}, this.renderState = l, this.parent = e, this.props = n, this.presenceContext = s, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = r, this.options = o, this.isControllingVariants = He(n), this.isVariantNode = kr(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: c, ...u } = this.scrapeMotionValuesFromProps(n, {});
    for (const f in u) {
      const p = u[f];
      a[f] !== void 0 && tt(p) && (p.set(a[f], !1), Ne(c) && c.add(f));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n) {
    return {};
  }
  mount(e) {
    this.current = e, wr.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, s) => this.bindToMotionValue(s, n)), zo.current || Qu(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Rn.current, process.env.NODE_ENV !== "production" && qn(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    wr.delete(this.current), this.projection && this.projection.unmount(), Ct(this.notifyUpdate), Ct(this.render), this.valueSubscriptions.forEach((e) => e()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features)
      this.features[e].unmount();
    this.current = null;
  }
  bindToMotionValue(e, n) {
    const s = Bt.has(e), r = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && $.update(this.notifyUpdate, !1, !0), s && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(e, () => {
      r(), i();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  loadFeatures({ children: e, ...n }, s, r, i) {
    let o, a;
    if (process.env.NODE_ENV !== "production" && r && s) {
      const l = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? xe(!1, l) : ft(!1, l);
    }
    for (let l = 0; l < ef; l++) {
      const c = Ko[l], { isEnabled: u, Feature: f, ProjectionNode: p, MeasureLayout: m } = pe[c];
      p && (o = p), u(n) && (!this.features[c] && f && (this.features[c] = new f(this)), m && (a = m));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && o) {
      this.projection = new o(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: l, layout: c, drag: u, dragConstraints: f, layoutScroll: p, layoutRoot: m } = n;
      this.projection.setOptions({
        layoutId: l,
        layout: c,
        alwaysMeasureLayout: !!u || f && Ht(f),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof c == "string" ? c : "both",
        initialPromotionConfig: i,
        layoutScroll: p,
        layoutRoot: m
      });
    }
    return a;
  }
  updateFeatures() {
    for (const e in this.features) {
      const n = this.features[e];
      n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : H();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(e, n = !0) {
    return this.makeTargetAnimatableFromInstance(e, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let s = 0; s < br.length; s++) {
      const r = br[s];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const i = e["on" + r];
      i && (this.propEventSubscriptions[r] = this.on(r, i));
    }
    this.prevMotionValues = tf(this, this.scrapeMotionValuesFromProps(e, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(e = !1) {
    if (e)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const s = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (s.initial = this.props.initial), s;
    }
    const n = {};
    for (let s = 0; s < nf; s++) {
      const r = Dn[s], i = this.props[r];
      (de(i) || i === !1) && (n[r] = i);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    n !== this.values.get(e) && (this.removeValue(e), this.bindToMotionValue(e, n)), this.values.set(e, n), this.latestValues[e] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let s = this.values.get(e);
    return s === void 0 && n !== void 0 && (s = qt(n, { owner: this }), this.addValue(e, s)), s;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e) {
    var n;
    return this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (n = this.getBaseTargetFromProps(this.props, e)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, e, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: s } = this.props, r = typeof s == "string" || typeof s == "object" ? (n = Xn(this.props, s)) === null || n === void 0 ? void 0 : n[e] : void 0;
    if (s && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !tt(i) ? i : this.initialValues[e] !== void 0 && r === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Yn()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class Yo extends sf {
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: s }) {
    delete n[e], delete s[e];
  }
  makeTargetAnimatableFromInstance({ transition: e, transitionEnd: n, ...s }, { transformValues: r }, i) {
    let o = xc(s, e || {}, this);
    if (r && (n && (n = r(n)), s && (s = r(s)), o && (o = r(o))), i) {
      yc(this, s, o);
      const a = Ju(this, s, o, n);
      n = a.transitionEnd, s = a.target;
    }
    return {
      transition: e,
      transitionEnd: n,
      ...s
    };
  }
}
function rf(t) {
  return window.getComputedStyle(t);
}
class of extends Yo {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(e, n) {
    if (Bt.has(n)) {
      const s = Zn(n);
      return s && s.default || 0;
    } else {
      const s = rf(e), r = (Or(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Oo(e, n);
  }
  build(e, n, s, r) {
    Fn(e, n, s, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n) {
    return Nn(e, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    tt(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(e, n, s, r) {
    Wr(e, n, s, r);
  }
}
class af extends Yo {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (Bt.has(n)) {
      const s = Zn(n);
      return s && s.default || 0;
    }
    return n = Ur.has(n) ? n : kn(n), e.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return H();
  }
  scrapeMotionValuesFromProps(e, n) {
    return Hr(e, n);
  }
  build(e, n, s, r) {
    $n(e, n, s, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(e, n, s, r) {
    Zr(e, n, s, r);
  }
  mount(e) {
    this.isSVGTag = Bn(e.tagName), super.mount(e);
  }
}
const lf = (t, e) => _n(t) ? new af(e, { enableHardwareAcceleration: !1 }) : new of(e, { enableHardwareAcceleration: !0 }), cf = {
  layout: {
    ProjectionNode: Ho,
    MeasureLayout: Bo
  }
}, uf = {
  ...Dc,
  ...nl,
  ...Bu,
  ...cf
}, pt = /* @__PURE__ */ ua((t, e) => Wa(t, e, uf, lf));
var pn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Cr;
function ff() {
  return Cr || (Cr = 1, function(t) {
    (function() {
      var e = {}.hasOwnProperty;
      function n() {
        for (var i = "", o = 0; o < arguments.length; o++) {
          var a = arguments[o];
          a && (i = r(i, s(a)));
        }
        return i;
      }
      function s(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var o = "";
        for (var a in i)
          e.call(i, a) && i[a] && (o = r(o, a));
        return o;
      }
      function r(i, o) {
        return o ? i ? i + " " + o : i + o : i;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(pn)), pn.exports;
}
var hf = ff();
const nt = /* @__PURE__ */ Yi(hf), df = "_root_wp9pz_9", pf = {
  root: df
}, Pr = {
  // Colors - Corporate
  bgDefault: "c-corporate-default-bg",
  cBlack: "c-corporate-default-black",
  cBlue: "c-corporate-default-blue",
  bgDark: "c-corporate-default-dark-bg",
  cDarkBlue: "c-corporate-default-dark-blue",
  cDarkGreen: "c-corporate-default-dark-green",
  cGreen: "c-corporate-default-green",
  cRichBlue: "c-corporate-default-rich-blue",
  // Colors - Grey Scale
  grey050: "c-grey-050",
  grey100: "c-grey-100",
  grey200: "c-grey-200",
  grey300: "c-grey-300",
  grey400: "c-grey-400",
  grey500: "c-grey-500",
  grey600: "c-grey-600",
  grey700: "c-grey-700",
  grey800: "c-grey-800",
  grey900: "c-grey-900",
  // Border Radius
  rFull: "radius-full",
  rL: "radius-l",
  rM: "radius-m",
  rNone: "radius-none",
  rS: "radius-s",
  rXL: "radius-xl",
  rXS: "radius-xs",
  rXXL: "radius-xxl",
  rXXS: "radius-xxs",
  // Padding
  pXXS: "p-xxs",
  pXS: "p-xs",
  pS: "p-s",
  pM: "p-m",
  pL: "p-l",
  pXL: "p-xl",
  pXXL: "p-xxl",
  pxXXS: "px-xxs",
  pxXS: "px-xs",
  pxS: "px-s",
  pxM: "px-m",
  pxL: "px-l",
  pxXL: "px-xl",
  pxXXL: "px-xxl",
  pyXXS: "py-xxs",
  pyXS: "py-xs",
  pyS: "py-s",
  pyM: "py-m",
  pyL: "py-l",
  pyXL: "py-xl",
  pyXXL: "py-xxl",
  ptXXS: "pt-xxs",
  ptXS: "pt-xs",
  ptS: "pt-s",
  ptM: "pt-m",
  ptL: "pt-l",
  ptXL: "pt-xl",
  ptXXL: "pt-xxl",
  prXXS: "pr-xxs",
  prXS: "pr-xs",
  prS: "pr-s",
  prM: "pr-m",
  prL: "pr-l",
  prXL: "pr-xl",
  prXXL: "pr-xxl",
  pbXXS: "pb-xxs",
  pbXS: "pb-xs",
  pbS: "pb-s",
  pbM: "pb-m",
  pbL: "pb-l",
  pbXL: "pb-xl",
  pbXXL: "pb-xxl",
  plXXS: "pl-xxs",
  plXS: "pl-xs",
  plS: "pl-s",
  plM: "pl-m",
  plL: "pl-l",
  plXL: "pl-xl",
  plXXL: "pl-xxl",
  // Margin
  mXXS: "m-xxs",
  mXS: "m-xs",
  mS: "m-s",
  mM: "m-m",
  mL: "m-l",
  mXL: "m-xl",
  mXXL: "m-xxl",
  mxXXS: "mx-xxs",
  mxXS: "mx-xs",
  mxS: "mx-s",
  mxM: "mx-m",
  mxL: "mx-l",
  mxXL: "mx-xl",
  mxXXL: "mx-xxl",
  myXXS: "my-xxs",
  myXS: "my-xs",
  myS: "my-s",
  myM: "my-m",
  myL: "my-l",
  myXL: "my-xl",
  myXXL: "my-xxl",
  mtXXS: "mt-xxs",
  mtXS: "mt-xs",
  mtS: "mt-s",
  mtM: "mt-m",
  mtL: "mt-l",
  mtXL: "mt-xl",
  mtXXL: "mt-xxl",
  mrXXS: "mr-xxs",
  mrXS: "mr-xs",
  mrS: "mr-s",
  mrM: "mr-m",
  mrL: "mr-l",
  mrXL: "mr-xl",
  mrXXL: "mr-xxl",
  mbXXS: "mb-xxs",
  mbXS: "mb-xs",
  mbS: "mb-s",
  mbM: "mb-m",
  mbL: "mb-l",
  mbXL: "mb-xl",
  mbXXL: "mb-xxl",
  mlXXS: "ml-xxs",
  mlXS: "ml-xs",
  mlS: "ml-s",
  mlM: "ml-m",
  mlL: "ml-l",
  mlXL: "ml-xl",
  mlXXL: "ml-xxl",
  // Font Sizes
  fsXXXS: "fs-xxxs",
  fsXXS: "fs-xxs",
  fsXS: "fs-xs",
  fsS: "fs-s",
  fsM: "fs-m",
  fsL: "fs-l",
  fsXL: "fs-xl",
  fsXXL: "fs-xxl",
  fsXXXL: "fs-xxxl",
  // Font Weights
  fwRegular: "fw-regular",
  fwSemibold: "fw-semibold",
  fwBold: "fw-bold",
  // Misc
  dBlock: "d-block",
  dInBlock: "d-in-block",
  taLeft: "ta-left",
  taCenter: "ta-center",
  mwSM: "mw-sm",
  mwMD: "mw-md",
  mwLG: "mw-lg",
  mwXL: "mw-xl",
  mwXXL: "mw-xxl",
  mw3XL: "mw-3xl"
};
function ht(t) {
  return t && Object.keys(t).length ? Object.keys(t).filter((e) => Object.keys(Pr).includes(e)).filter((e) => t[e] === !0).map((e) => Pr[e]) : null;
}
function at(t) {
  if (t)
    return t.trim().split(" ").filter((e) => e.length);
}
function lt(t) {
  return t ? t.split("").reduce((e, n) => (/[A-Z]/.test(n) ? t.indexOf(n) === 0 ? e += n.toLowerCase() : e += "-" + n.toLowerCase() : e += n, e), "") : "";
}
const qo = "Anchor";
function Jo({
  as: t,
  wrapper: e,
  children: n,
  variant: s = "default",
  className: r,
  animate: i = !0,
  animationDelay: o = 0,
  href: a,
  target: l,
  rel: c,
  linkProps: u = {},
  style: f,
  ...p
}, m) {
  const g = e || "span", y = i ? pt[g] : g, C = t || "a", P = ht(p) ?? [], w = i ? {
    initial: { opacity: 0, y: 5 },
    animate: { opacity: 1, y: 0 },
    transition: { delay: o, duration: 0.2 }
  } : {}, T = c || (l === "_blank" ? { rel: "noopener noreferrer" } : {}).rel;
  return /* @__PURE__ */ d.jsx(
    y,
    {
      className: nt(
        // The root class from our CSS module
        pf.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + lt(qo),
        // User's own class(es)
        at(r),
        ...P
      ),
      "data-variant": s,
      ...f ? { style: f } : {},
      ...w,
      ...p,
      children: /* @__PURE__ */ d.jsx(
        C,
        {
          ref: m,
          href: a,
          target: l,
          rel: T,
          ...u,
          children: n
        }
      )
    }
  );
}
Jo.displayName = qo;
const Tp = S(Jo), mf = "_root_16h2x_9", gf = "_avatar_16h2x_26", yf = "_embedded_16h2x_36", vf = "_label_16h2x_45", Le = {
  root: mf,
  avatar: gf,
  embedded: yf,
  label: vf
}, Qo = "Avatar", xf = "https://i.pravatar.cc/150", ti = S(
  ({
    numberOfAvatars: t,
    variant: e = "default",
    label: n,
    className: s,
    animate: r = !0,
    animationDelay: i = 0,
    baseImageUrl: o = xf,
    style: a,
    ...l
  }, c) => {
    const u = Yt(() => {
      const m = Math.floor(Math.random() * 50);
      return Array.from({ length: t }, (g, y) => /* @__PURE__ */ d.jsx(
        "div",
        {
          className: nt(
            Le.avatar,
            e === "embedded" && Le.embedded
          ),
          style: {
            backgroundImage: `url(${o}?img=${m + y})`
          },
          role: "img",
          "aria-label": `Avatar ${y + 1}`
        },
        y
      ));
    }, [t, e, o]), f = Yt(() => nt(
      Le.root,
      "airc-ui__" + lt(Qo),
      at(s),
      ...ht(l) ?? []
    ), [s, l]), p = ({ children: m, ...g }) => r ? /* @__PURE__ */ d.jsx(
      pt.div,
      {
        className: f,
        ref: c,
        ...g,
        ...a ? { style: a } : {},
        initial: { opacity: 0, scale: 0.9 },
        animate: { opacity: 1, scale: 1 },
        transition: { delay: i, duration: 0.2 },
        children: m
      }
    ) : /* @__PURE__ */ d.jsx(
      "div",
      {
        ref: c,
        className: f,
        ...g,
        ...a ? { style: a } : {},
        children: m
      }
    );
    return /* @__PURE__ */ d.jsxs(p, { ...l, children: [
      u,
      n && /* @__PURE__ */ d.jsx("span", { className: Le.label, "aria-label": n, children: n })
    ] });
  }
);
ti.displayName = Qo;
const Mp = ti, wf = "_root_178it_9", bf = "_content_178it_13", Sr = {
  root: wf,
  content: bf
}, ei = "Callout";
function ni({ children: t, className: e, variant: n, style: s, ...r }, i) {
  const o = ht(r) ?? [];
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: i,
      className: nt(
        // The root class from our CSS module
        Sr.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + lt(ei),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        at(e),
        ...o
      ),
      "data-variant": n,
      ...s ? { style: s } : {},
      ...r,
      children: /* @__PURE__ */ d.jsx("p", { className: Sr.content, children: t })
    }
  );
}
ni.displayName = ei;
const jp = S(ni), Cf = "_root_hsiw9_9", Pf = "_content_hsiw9_38", Tr = {
  root: Cf,
  content: Pf
}, si = "Card";
function ri({
  as: t,
  children: e,
  className: n,
  variant: s = "default",
  animate: r = !0,
  animationDelay: i = 0,
  style: o,
  clickable: a = !1,
  onClick: l,
  ...c
}, u) {
  const f = t || "article", p = r ? pt[f] : f, m = ht(c) ?? [], g = r ? {
    initial: { opacity: 0, y: -10 },
    animate: { opacity: 1, y: 0 },
    transition: { delay: i, duration: 0.3 }
  } : {};
  return /* @__PURE__ */ d.jsx(
    p,
    {
      ref: u,
      className: nt(
        // The root class from our CSS module
        Tr.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + lt(si),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        at(n),
        ...m
      ),
      "data-variant": s,
      "data-clickable": a || !!l,
      onClick: l,
      ...o ? { style: o } : {},
      ...g,
      ...c,
      children: s === "bare" ? e : /* @__PURE__ */ d.jsx("div", { className: Tr.content, children: e })
    }
  );
}
ri.displayName = si;
const Ap = S(ri), Sf = "_root_1hgh0_12", Tf = {
  root: Sf
}, oi = "Chip";
function ii({
  as: t,
  children: e,
  className: n,
  animate: s = !0,
  animationDelay: r = 0,
  style: i,
  ...o
}, a) {
  const l = t || "span", c = s ? pt[l] : l, u = ht(o) ?? [], f = s ? {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { delay: r, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ d.jsx(
    c,
    {
      ref: a,
      className: nt(
        Tf.root,
        "airc-ui__" + lt(oi),
        at(n),
        ...u
      ),
      ...i ? { style: i } : {},
      ...f,
      ...o,
      children: e
    }
  );
}
ii.displayName = oi;
const Rp = S(ii), Mf = "_root_1mt7u_12", jf = "_icon_1mt7u_51", mn = {
  root: Mf,
  icon: jf
}, Af = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m5 15 7 7m0 0 7-7m-7 7V2"
        }
      )
    ]
  }
), Rf = S(Af), Vf = A(Rf), Lf = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m9 5-7 7m0 0 7 7m-7-7h20"
        }
      )
    ]
  }
), kf = S(Lf), Ef = A(kf), Df = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m15 5 7 7m0 0-7 7m7-7H2"
        }
      )
    ]
  }
), _f = S(Df), Ff = A(_f), Of = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M19.071 14.828v-9.9m0 0h-9.9m9.9 0L4.93 19.072"
        }
      )
    ]
  }
), $f = S(Of), Bf = A($f), Nf = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m5 9 7-7m0 0 7 7m-7-7v20"
        }
      )
    ]
  }
), Xf = S(Nf), If = A(Xf), Wf = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1a1 1 0 0 1 1 1v7.586l5.364-5.364a1 1 0 1 1 1.414 1.414L14.414 11H22a1 1 0 1 1 0 2h-7.586l5.364 5.364a1 1 0 0 1-1.414 1.414L13 14.414V22a1 1 0 1 1-2 0v-7.586l-5.364 5.364a1 1 0 0 1-1.414-1.414L9.586 13H2a1 1 0 1 1 0-2h7.586L4.222 5.636a1 1 0 1 1 1.414-1.414L11 9.586V2a1 1 0 0 1 1-1Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Uf = S(Wf), Zf = A(Uf), Hf = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 1.5,
          d: "m5 11 5 5 8-8"
        }
      )
    ]
  }
), Gf = S(Hf), zf = A(Gf), Kf = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.739 3.848a6 6 0 1 1 7.761 8.849V21a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 21v-8.527a4.5 4.5 0 1 1 2.239-8.625ZM14.5 2.5a4.995 4.995 0 0 0-4.18 2.255l-.252.384-.404-.219A3.5 3.5 0 1 0 8 11.5h.5V21a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-8.906l.272-.139A5 5 0 0 0 14.5 2.5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.5 19.5A.5.5 0 0 1 8 19h5a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5ZM7.5 17.5A.5.5 0 0 1 8 17h3a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Yf = S(Kf), qf = A(Yf), Jf = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m3 9 9 6 9-6"
        }
      )
    ]
  }
), Qf = S(Jf), th = A(Qf), eh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m15 3-6 9 6 9"
        }
      )
    ]
  }
), nh = S(eh), sh = A(nh), rh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m9 3 6 9-6 9"
        }
      )
    ]
  }
), oh = S(rh), ih = A(oh), ah = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m3 15 9-6 9 6"
        }
      )
    ]
  }
), lh = S(ah), ch = A(lh), uh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM2.5 12a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 5.5a.5.5 0 0 1 .5.5v5.793l1.854 1.853a.5.5 0 0 1-.708.708l-2-2A.5.5 0 0 1 11.5 12V6a.5.5 0 0 1 .5-.5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), fh = S(uh), hh = A(fh), dh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 1.5,
          d: "M18.364 5.636 5.636 18.364M5.636 5.636l12.728 12.728"
        }
      )
    ]
  }
), ph = S(dh), mh = A(ph), gh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2.5 3A2.5 2.5 0 0 1 5 .5h10A2.5 2.5 0 0 1 17.5 3v14a2.5 2.5 0 0 1-2.5 2.5H5A2.5 2.5 0 0 1 2.5 17V3ZM5 1.5A1.5 1.5 0 0 0 3.5 3v14A1.5 1.5 0 0 0 5 18.5h10a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 15 1.5H5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 4.5h-2v-1h2A2.5 2.5 0 0 1 21.5 6v14a2.5 2.5 0 0 1-2.5 2.5H9A2.5 2.5 0 0 1 6.5 20v-1h1v1A1.5 1.5 0 0 0 9 21.5h10a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 19 4.5Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), yh = S(gh), vh = A(yh), xh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsxs("g", { transform: "scale(1.333) translate(0, 6)", children: [
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M16 1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ d.jsx("path", { fill: "currentColor", d: "M0 3h18v3H0V3Z" })
      ] })
    ]
  }
), wh = S(xh), bh = A(wh), Ch = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 1.5,
          d: "M4 12h16M4 12h16"
        }
      )
    ]
  }
), Ph = S(Ch), Sh = A(Ph), Th = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 1.5,
          d: "M4 9h16M4 15h16"
        }
      )
    ]
  }
), Mh = S(Th), jh = A(Mh), Ah = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M20 9.79c0 1-.38 1.862-1.141 2.582-.72.681-1.622 1.021-2.703 1.021-1.481 0-2.723-.52-3.724-1.561-.96-1.041-1.441-2.383-1.441-4.024 0-3.003 1.161-5.145 3.484-6.427C16.155.461 17.517 0 18.559 0c.44 0 .66.16.66.48 0 .28-.24.481-.72.601-3.324.881-4.985 2.543-4.985 4.985 0 1.081.28 2.002.84 2.763.08-1.362.941-2.042 2.583-2.042.88 0 1.601.3 2.162.9.6.561.901 1.262.901 2.103Zm-11.051 0c0 1-.38 1.862-1.141 2.582-.72.681-1.602 1.021-2.643 1.021-1.521 0-2.763-.52-3.724-1.561C.481 10.75 0 9.389 0 7.748 0 4.785 1.161 2.663 3.483 1.38 5.165.461 6.507 0 7.508 0c.44 0 .66.16.66.48 0 .28-.24.481-.72.601-3.284.881-4.925 2.563-4.925 5.045 0 1.041.28 1.942.84 2.703.08-1.362.921-2.042 2.523-2.042.88 0 1.601.3 2.162.9.6.561.9 1.262.9 2.103Z"
        }
      )
    ]
  }
), Rh = S(Ah), Vh = A(Rh), Lh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2.6,
          d: "M16 8L8 16M8 8l8 8"
        }
      )
    ]
  }
), kh = S(Lh), Eh = A(kh), Dh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 13.5a.5.5 0 0 1 .5.5v5a2.5 2.5 0 0 1-2.5 2.5h-5a.5.5 0 0 1 0-1h5a1.5 1.5 0 0 0 1.5-1.5v-5a.5.5 0 0 1 .5-.5ZM3 13.5a.5.5 0 0 0-.5.5v5A2.5 2.5 0 0 0 5 21.5h5a.5.5 0 0 0 0-1H5A1.5 1.5 0 0 1 3.5 19v-5a.5.5 0 0 0-.5-.5ZM3 10.5a.5.5 0 0 1-.5-.5V5A2.5 2.5 0 0 1 5 2.5h5a.5.5 0 0 1 0 1H5A1.5 1.5 0 0 0 3.5 5v5a.5.5 0 0 1-.5.5ZM21 10.5a.5.5 0 0 0 .5-.5V5A2.5 2.5 0 0 0 19 2.5h-5a.5.5 0 0 0 0 1h5A1.5 1.5 0 0 1 20.5 5v5a.5.5 0 0 0 .5.5Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20.354 3.646a.5.5 0 0 1 0 .708l-16 16a.5.5 0 0 1-.708-.708l16-16a.5.5 0 0 1 .708 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20.354 3.646a.5.5 0 0 1 0 .708l-16 16a.5.5 0 0 1-.708-.708l16-16a.5.5 0 0 1 .708 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), _h = S(Dh), Fh = A(_h), Oh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 1.5,
          d: "M22.25 12c0 .385-.224.975-.785 1.699-.544.703-1.342 1.449-2.323 2.132C17.174 17.2 14.571 18.25 12 18.25c-2.571 0-5.174-1.048-7.142-2.42-.981-.682-1.779-1.428-2.323-2.131-.56-.724-.785-1.314-.785-1.699s.224-.975.785-1.699c.544-.703 1.342-1.449 2.323-2.132C6.826 6.8 9.429 5.75 12 5.75c2.571 0 5.174 1.048 7.142 2.42.981.682 1.779 1.428 2.323 2.131.56.724.785 1.314.785 1.699Z"
        }
      ),
      /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 4.25, stroke: "currentColor", strokeWidth: 1.5 })
    ]
  }
), $h = S(Oh), Bh = A($h), Nh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21.579 4.523a.75.75 0 0 1-.102 1.056l-17 14a.75.75 0 0 1-.954-1.158l17-14a.75.75 0 0 1 1.056.102Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16.42 5.877C15.023 5.337 13.513 5 12 5 6.477 5 1 9.477 1 12c0 1.198 1.236 2.838 3.126 4.23l1.184-.998-.024-.017c-.931-.649-1.67-1.344-2.158-1.975-.521-.674-.628-1.1-.628-1.24 0-.14.107-.566.628-1.24.489-.63 1.227-1.326 2.158-1.975C7.163 7.477 9.62 6.5 12 6.5c1.033 0 2.08.184 3.087.499l1.332-1.122Zm-2.045 1.722a5 5 0 0 0-7.116 5.993l1.279-1.078a3.5 3.5 0 0 1 4.559-3.839L14.374 7.6Zm.073 1.9 1.15-.97a5 5 0 1 1-7.632 6.427l1.152-.97a3.5 3.5 0 1 0 5.33-4.488ZM6.66 16.054C8.287 16.92 10.166 17.5 12 17.5c2.38 0 4.837-.977 6.714-2.285.931-.649 1.67-1.344 2.158-1.975.521-.674.628-1.1.628-1.24 0-.14-.107-.566-.628-1.24-.489-.63-1.227-1.326-2.158-1.975a13.611 13.611 0 0 0-2.033-1.168l1.252-1.054C20.873 8.097 23 10.428 23 12c0 2.523-5.477 7-11 7-2.333 0-4.658-.799-6.565-1.912l1.227-1.033Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Xh = S(Nh), Ih = A(Xh), Wh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          transform: "scale(1.2) translate(-2.4, -2.4)",
          d: "M12 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19ZM13.286 14.518h2.459l.386-2.498h-2.845v-1.365c0-1.037.338-1.957 1.309-1.957h1.56v-2.18c-.275-.037-.854-.118-1.949-.118-2.287 0-3.627 1.208-3.627 3.959v1.661h-2.35v2.498h2.35v6.864c.465.07.937.118 1.421.118.438 0 .864-.04 1.286-.097v-6.885Z"
        }
      )
    ]
  }
), Uh = S(Wh), Zh = A(Uh), Hh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2.6,
          d: "M12 11v6M12 7v0"
        }
      )
    ]
  }
), Gh = S(Hh), zh = A(Gh), Kh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          transform: "scale(1.2) translate(-2.4, -2.4)",
          d: "M8 3a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H8Zm10 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-6 2a5 5 0 1 1-.001 10.001A5 5 0 0 1 12 7Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
        }
      )
    ]
  }
), Yh = S(Kh), qh = A(Yh), Jh = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          transform: "scale(1.2) translate(-2.4, -2.4)",
          d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2ZM9 17H6.477v-7H9v7ZM7.694 8.717c-.771 0-1.286-.514-1.286-1.2 0-.686.514-1.2 1.371-1.2.771 0 1.286.514 1.286 1.2 0 .686-.514 1.2-1.371 1.2ZM18 17h-2.442v-3.826c0-1.058-.651-1.302-.895-1.302s-1.058.163-1.058 1.302V17h-2.523v-7h2.523v.977c.325-.57.976-.977 2.197-.977S18 10.977 18 13.174V17Z"
        }
      )
    ]
  }
), Qh = S(Jh), td = A(Qh), ed = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1.5A7.5 7.5 0 0 0 4.5 9c0 1.234.457 2.51 1.182 3.753.723 1.239 1.694 2.412 2.678 3.432a30.538 30.538 0 0 0 3.595 3.164l.045.033.045-.033a30.547 30.547 0 0 0 3.595-3.164c.984-1.02 1.955-2.193 2.678-3.432C19.043 11.51 19.5 10.234 19.5 9A7.5 7.5 0 0 0 12 1.5ZM12 20l-.286.41-.002-.002-.005-.003-.019-.013a11.817 11.817 0 0 1-.33-.242A31.526 31.526 0 0 1 7.64 16.88c-1.017-1.053-2.046-2.291-2.823-3.622C4.043 11.928 3.5 10.475 3.5 9a8.5 8.5 0 0 1 17 0c0 1.475-.543 2.928-1.318 4.257-.777 1.331-1.806 2.569-2.822 3.622a31.52 31.52 0 0 1-4.048 3.513l-.019.013-.005.003-.001.002L12 20Zm0 0 .287.41-.287.2-.286-.2L12 20Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx("path", { fill: "currentColor", d: "M14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.216 18.542c-.95-.381-2.326-.691-3.97-.872l.11-.994c1.693.186 3.167.51 4.232.937.53.213.987.462 1.32.753.33.288.592.669.592 1.134 0 .606-.436 1.065-.933 1.391-.516.34-1.231.626-2.07.859-1.683.467-3.98.75-6.497.75s-4.814-.283-6.498-.75c-.838-.233-1.553-.52-2.07-.859-.495-.326-.932-.785-.932-1.391 0-.46.256-.837.58-1.125.327-.288.776-.536 1.296-.747 1.045-.425 2.491-.75 4.155-.939l.113.994c-1.614.184-2.962.494-3.891.871-.467.19-.8.386-1.01.57-.21.187-.243.313-.243.376 0 .085.067.283.482.555.394.26.997.511 1.788.731 1.574.437 3.777.714 6.23.714 2.453 0 4.656-.277 6.23-.714.79-.22 1.394-.472 1.788-.73.415-.273.482-.471.482-.556 0-.063-.034-.192-.25-.382-.215-.187-.557-.385-1.034-.576Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), nd = S(ed), sd = A(nd), rd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M1 9c6.4 0 8-1.6 8-8 0 6.4 1.6 8 8 8-6.4 0-8 1.6-8 8 0-6.4-1.6-8-8-8ZM12 17.5c4.4 0 5.5-1.1 5.5-5.5 0 4.4 1.1 5.5 5.5 5.5-4.4 0-5.5 1.1-5.5 5.5 0-4.4-1.1-5.5-5.5-5.5Z"
        }
      )
    ]
  }
), od = S(rd), id = A(od), ad = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.37 10.406a5.769 5.769 0 0 0-2.65-2.651.5.5 0 1 1 .446-.895 6.767 6.767 0 0 1 3.099 3.099.5.5 0 1 1-.895.447ZM18.917 10.118c-1.366-2.732-3.409-4.775-6.14-6.14a.5.5 0 1 1 .447-.895c2.925 1.463 5.125 3.662 6.587 6.588a.5.5 0 1 1-.894.447ZM5.178 4.435a.5.5 0 0 0-.76.063L2.771 6.802c-.606.848-.618 1.968-.013 2.786 1.257 1.699 3.133 4.046 5.12 6.033s4.334 3.863 6.033 5.12c.818.605 1.938.593 2.786-.013l2.304-1.645a.5.5 0 0 0 .063-.76l-2.899-2.9a.5.5 0 0 0-.577-.093l-1.072.536c-.828.414-1.858.489-2.694-.116-.567-.41-1.301-1.02-2.177-1.896A17.36 17.36 0 0 1 7.961 11.9c-.703-.953-.696-2.179-.196-3.179l.405-.81a.5.5 0 0 0-.094-.578L5.178 4.435Zm-1.574-.518a1.5 1.5 0 0 1 2.281-.189l2.898 2.898a1.5 1.5 0 0 1 .281 1.732l-.405.81c-.362.725-.336 1.54.106 2.138.385.52.91 1.163 1.588 1.84.844.844 1.538 1.42 2.056 1.793.453.328 1.065.33 1.66.033l1.073-.536a1.5 1.5 0 0 1 1.732.28l2.898 2.899a1.5 1.5 0 0 1-.189 2.281l-2.304 1.646c-1.18.843-2.776.88-3.962.003-1.72-1.273-4.11-3.181-6.145-5.217-2.036-2.035-3.944-4.425-5.217-6.145-.877-1.186-.84-2.781.003-3.962l1.646-2.304Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ld = S(ad), cd = A(ld), ud = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M7 5.79v12.42a1 1 0 0 0 1.524.852l10.092-6.21a1 1 0 0 0 0-1.704L8.524 4.938A1 1 0 0 0 7 5.79Z"
        }
      )
    ]
  }
), fd = S(ud), hd = A(fd), dd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 1.5,
          d: "M12 3v18M3 12h18"
        }
      )
    ]
  }
), pd = S(dd), md = A(pd), gd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 14.5A5.5 5.5 0 0 0 2.5 20 1.5 1.5 0 0 0 4 21.5h16a1.5 1.5 0 0 0 1.5-1.5 5.5 5.5 0 0 0-5.5-5.5H8ZM1.5 20A6.5 6.5 0 0 1 8 13.5h8a6.5 6.5 0 0 1 6.5 6.5 2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 20ZM12 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM6.5 7a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), yd = S(gd), vd = A(yd), xd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1.5 10a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.646 15.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), wd = S(xd), bd = A(wd), Cd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M2 12v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5M12 15V5M6 7l4.211-2.106a4 4 0 0 1 3.578 0L18 7"
        }
      )
    ]
  }
), Pd = S(Cd), Sd = A(Pd), Td = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2.6,
          d: "M8 12.5L10.5 15L16 9"
        }
      )
    ]
  }
), Md = S(Td), jd = A(Md), Ad = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 1a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM12 19.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5ZM19.5 12a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM6.697 6.697a.5.5 0 0 1-.707 0L3.868 4.575a.5.5 0 1 1 .707-.707L6.697 5.99a.5.5 0 0 1 0 .707ZM6.697 17.303a.5.5 0 0 1 0 .707l-2.122 2.122a.5.5 0 1 1-.707-.707l2.122-2.122a.5.5 0 0 1 .707 0ZM12 .5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5ZM.5 12a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5ZM20.132 20.132a.5.5 0 0 1-.707 0l-2.122-2.122a.5.5 0 1 1 .707-.707l2.122 2.122a.5.5 0 0 1 0 .707ZM20.132 3.868a.5.5 0 0 1 0 .707L18.01 6.697a.5.5 0 1 1-.707-.707l2.122-2.122a.5.5 0 0 1 .707 0Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Rd = S(Ad), Vd = A(Rd), Ld = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 8, stroke: "currentColor" }),
      /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 4, fill: "currentColor" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M12 22v-4M22 12h-4M12 6V2M6 12H2"
        }
      )
    ]
  }
), kd = S(Ld), Ed = A(kd), Dd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M14.507 5H9.493A3 3 0 0 0 6.52 7.604l-1.067 8A3 3 0 0 0 8.427 19h7.146a3 3 0 0 0 2.974-3.396l-1.067-8A3 3 0 0 0 14.508 5Z"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M17.5 7H19a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-.5"
        }
      ),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5.5 16 1 11V8l5 2"
        }
      )
    ]
  }
), _d = S(Dd), Fd = A(_d), Od = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          transform: "scale(1.2) translate(-2.4, -2.4)",
          d: "M19.68 1.92H4.32a2.403 2.403 0 0 0-2.4 2.4v15.36c0 1.323 1.077 2.4 2.4 2.4h15.36c1.323 0 2.4-1.077 2.4-2.4V4.32c0-1.323-1.077-2.4-2.4-2.4Zm-1.917 8.795a3.596 3.596 0 0 1-3.34-1.61v5.538a4.093 4.093 0 1 1-4.093-4.093c.085 0 .169.008.253.013v2.017c-.084-.01-.167-.025-.253-.025a2.089 2.089 0 1 0 0 4.178c1.154 0 2.173-.91 2.173-2.063l.02-9.405h1.927a3.594 3.594 0 0 0 3.313 3.208v2.242Z"
        }
      )
    ]
  }
), $d = S(Od), Bd = A($d), Nd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor" }),
      /* @__PURE__ */ d.jsx(
        "path",
        {
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2.6,
          d: "M12 7v5M12 17v0"
        }
      )
    ]
  }
), Xd = S(Nd), Id = A(Xd), Wd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          transform: "scale(1.2) translate(-2.4, -2.4)",
          d: "M19.077 4.928A9.927 9.927 0 0 0 12.011 2c-5.506 0-9.987 4.479-9.989 9.985a9.962 9.962 0 0 0 1.333 4.992L2 22l5.233-1.237a9.98 9.98 0 0 0 4.773 1.216h.004c5.505 0 9.986-4.48 9.989-9.985a9.922 9.922 0 0 0-2.922-7.066Zm-2.179 10.626c-.208.583-1.227 1.145-1.685 1.186-.458.042-.887.207-2.995-.624-2.537-1-4.139-3.601-4.263-3.767-.125-.167-1.019-1.353-1.019-2.581s.645-1.832.874-2.081a.916.916 0 0 1 .666-.312c.166 0 .333 0 .478.006.178.007.375.016.562.431.222.494.707 1.728.769 1.853.062.125.104.271.021.437-.083.166-.125.27-.249.416-.125.146-.262.325-.374.437-.125.124-.255.26-.11.509.146.25.646 1.067 1.388 1.728.954.85 1.757 1.113 2.007 1.239.25.125.395.104.541-.063.146-.166.624-.728.79-.978.166-.25.333-.208.562-.125.229.083 1.456.687 1.705.812.25.125.416.187.478.291.062.103.062.603-.146 1.186Z"
        }
      )
    ]
  }
), Ud = S(Wd), Zd = A(Ud), Hd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsxs("g", { transform: "scale(1.2) translate(-2.4, -2.4)", children: [
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M20.5 3 4.965 21H3.108L18.643 3H20.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "currentColor",
            fillOpacity: "0.3",
            fillRule: "evenodd",
            d: "M15.572 20.5 3.91 3.5h4.479l11.661 17h-4.479Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m7.862 4.5 10.29 15h-2.054L5.81 4.5h2.053Zm.79-1.5h-5.69l12.346 18H21L8.652 3Z",
            clipRule: "evenodd"
          }
        )
      ] })
    ]
  }
), Gd = S(Hd), zd = A(Gd), Kd = ({ title: t, titleId: e, ...n }, s) => /* @__PURE__ */ d.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: s,
    "aria-labelledby": e,
    viewBox: "0 0 24 24",
    ...n,
    children: [
      t ? /* @__PURE__ */ d.jsx("title", { id: e, children: t }) : null,
      /* @__PURE__ */ d.jsx(
        "path",
        {
          fill: "currentColor",
          transform: "scale(1.2) translate(-2.4, -2.4)",
          d: "M21.551 6.96c-.191-1.056-1.102-1.824-2.16-2.064-1.582-.336-4.511-.576-7.68-.576-3.167 0-6.142.24-7.727.576-1.055.24-1.968.96-2.16 2.064-.193 1.2-.384 2.88-.384 5.04s.191 3.84.431 5.04c.193 1.056 1.105 1.824 2.16 2.064 1.68.336 4.56.576 7.729.576 3.169 0 6.049-.24 7.729-.576 1.055-.24 1.967-.96 2.16-2.064.19-1.2.43-2.929.48-5.04-.098-2.16-.338-3.84-.578-5.04ZM9.12 15.36V8.64L14.976 12 9.12 15.36Z"
        }
      )
    ]
  }
), Yd = S(Kd), qd = A(Yd), Mr = {
  ArrowDown: Vf,
  ArrowLeft: Ef,
  ArrowRight: Ff,
  ArrowTopRight: Bf,
  ArrowUp: If,
  Asterisk: Zf,
  Check: zf,
  Chef: qf,
  ChevronDown: th,
  ChevronLeft: sh,
  ChevronRight: ih,
  ChevronUp: ch,
  Clock: hh,
  Close: mh,
  Copy: vh,
  CreditCard: bh,
  Dash: Sh,
  DoubleDash: jh,
  DoubleQuotes: Vh,
  Error: Eh,
  Expand: Fh,
  Eye: Bh,
  EyeCrossed: Ih,
  Facebook: Zh,
  Info: zh,
  Instagram: qh,
  LinkedIn: td,
  Location: sd,
  Magic: id,
  Phone: cd,
  Play: hd,
  Plus: md,
  Profile: vd,
  Search: bd,
  Share: Sd,
  Success: jd,
  Sun: Vd,
  Target: Ed,
  Teapot: Fd,
  TikTok: Bd,
  Warning: Id,
  Whatsapp: Zd,
  X: zd,
  Youtube: qd
};
function Jd(t) {
  return Ki(t) || typeof t == "function";
}
function Qd(t) {
  return t ? typeof t == "string" || typeof t == "object" && "name" in t : !1;
}
function tp(t) {
  return !!t && typeof t == "object" && "path" in t;
}
const ai = "Icon";
function li({
  as: t,
  icon: e,
  iconRef: n,
  label: s,
  size: r = "S",
  radius: i,
  variant: o = "default",
  className: a,
  animate: l = !0,
  animationDelay: c = 0,
  style: u,
  ...f
}, p) {
  const m = t || "span", g = l ? pt[m] : m;
  function y(w) {
    if (Qd(w)) {
      const x = typeof w == "string" ? w : w.name;
      return Mr[x] ? Ar(Mr[x], {
        ...n ? { ref: n } : {},
        ...s ? {
          title: s,
          titleId: s.trim().toLowerCase().replace(/[^a-z0-9\s_-]/g, "").replace(/\s+/g, "_") + "_id"
        } : {},
        className: mn.icon
      }) : 'No icon found for "' + x + '"!';
    }
    return tp(w) ? (o !== "default" && console.warn("Warning: cannot set icon stroke on a remote asset"), /* @__PURE__ */ d.jsx(
      "img",
      {
        ...n ? { ref: n } : {},
        src: w.path,
        alt: `Icona decorativa${s ? " che rappresenta '" + s + "'" : ""}`,
        className: mn.icon
      }
    )) : "No icon provided";
  }
  const C = ht(f) ?? [], P = l ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: c, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ d.jsx(
    g,
    {
      ref: p,
      className: nt(
        "airc-ui__" + lt(ai),
        mn.root,
        at(a),
        ...C
      ),
      ...u ? { style: u } : {},
      "data-variant": o,
      "data-size": r,
      ...i ? { "data-radius": i } : {},
      ...P,
      ...f,
      children: y(e)
    }
  );
}
li.displayName = ai;
const ep = S(li), np = "_root_1sngz_9", sp = {
  root: np
}, ci = "IconButton";
function ui({
  as: t,
  children: e,
  className: n,
  variant: s = "default",
  animate: r = !0,
  animationDelay: i = 0,
  style: o,
  ariaLabel: a,
  href: l,
  target: c,
  rel: u,
  disabled: f = !1,
  ...p
}, m) {
  const g = t || "button", y = r ? pt[g] : g, C = ht(p) ?? [], P = r ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: i, duration: 0.2 }
  } : {}, w = g === "a" ? {
    href: l ?? "/",
    target: c ?? "_blank",
    rel: c === "_blank" ? "noopener noreferrer" : u
  } : {};
  return /* @__PURE__ */ d.jsx(
    y,
    {
      ref: m,
      className: nt(
        // The root class from our CSS module
        sp.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + lt(ci),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        at(n),
        ...C
      ),
      "data-variant": s,
      "data-element": g,
      "aria-label": a,
      disabled: f,
      ...o ? { style: o } : {},
      ...P,
      ...w,
      ...p,
      children: e
    }
  );
}
ui.displayName = ci;
const rp = S(
  ui
), op = "_root_1ec2x_9", ip = {
  root: op
}, fi = "OpeningTitle";
function hi({
  as: t,
  children: e,
  className: n,
  alignment: s = "center",
  variant: r = "default",
  size: i = "md",
  animate: o = !0,
  animationDelay: a = 0,
  style: l,
  ...c
}, u) {
  const f = t || "span", p = o ? pt[f] : f, m = ht(c) ?? [], g = o ? {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { delay: a, duration: 0.3 }
  } : {};
  return /* @__PURE__ */ d.jsx(
    p,
    {
      ref: u,
      className: nt(
        // The root class from our CSS module
        ip.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + lt(fi),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        at(n),
        ...m
      ),
      "data-variant": r,
      "data-alignment": s,
      "data-size": i,
      ...l ? { style: l } : {},
      ...g,
      ...c,
      children: e
    }
  );
}
hi.displayName = fi;
const Vp = S(
  hi
), ap = "_root_629ju_9", lp = {
  root: ap
}, di = "PlayButton";
function pi({
  className: t,
  iconColor: e = "#fff",
  ariaLabel: n = "Riproduci il video",
  ...s
}, r) {
  return /* @__PURE__ */ d.jsx(
    rp,
    {
      ref: r,
      variant: "bare",
      className: nt(
        "airc-ui__" + lt(di),
        at(t)
      ),
      ariaLabel: n,
      ...s,
      children: /* @__PURE__ */ d.jsx("span", { className: lp.root, children: /* @__PURE__ */ d.jsx(
        "svg",
        {
          width: 40,
          height: 41,
          viewBox: "0 0 40 41",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          color: e,
          children: /* @__PURE__ */ d.jsx(
            "path",
            {
              d: "M11.667 8.95656V32.0441C11.667 32.8264 12.5248 33.3058 13.1911 32.8958L31.9497 21.352C32.5842 20.9615 32.5842 20.0392 31.9497 19.6487L13.1911 8.1049C12.5248 7.69489 11.667 8.17423 11.667 8.95656Z",
              fill: "currentColor"
            }
          )
        }
      ) })
    }
  );
}
pi.displayName = di;
const Lp = S(
  pi
), cp = "_root_1amq8_9", up = "_progress_1amq8_26", jr = {
  root: cp,
  progress: up
}, mi = "ProgressBar";
function fp(t, e) {
  if (e === 0)
    return 0;
  const n = t / e * 100;
  return Math.floor(Math.min(n, 100));
}
function gi({
  as: t,
  progress: e,
  className: n,
  animate: s = !0,
  animationDelay: r = 0,
  style: i,
  ariaLabel: o,
  ...a
}, l) {
  const c = t || "div", { part: u, whole: f } = e ?? {};
  if (typeof u > "u" || typeof f > "u")
    return null;
  const p = ht(a) ?? [], m = fp(u, f), g = (y) => s ? /* @__PURE__ */ d.jsx(
    pt.div,
    {
      ...y,
      initial: { width: 0 },
      animate: { width: `${m}%` },
      transition: { delay: r, duration: 0.3 }
    }
  ) : /* @__PURE__ */ d.jsx("div", { ...y, style: { width: `${m}%` } });
  return /* @__PURE__ */ d.jsx(
    c,
    {
      ref: l,
      role: "progressbar",
      "aria-valuenow": m,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-label": o || "Progress bar",
      className: nt(
        // The root class from our CSS module
        jr.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + lt(mi),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        at(n),
        ...p
      ),
      ...i ? { style: i } : {},
      ...a,
      children: /* @__PURE__ */ d.jsx(g, { className: jr.progress })
    }
  );
}
gi.displayName = mi;
const kp = S(
  gi
), hp = "_root_dz2zy_12", dp = "_container_dz2zy_15", pp = "_label_dz2zy_24", mp = "_icon_dz2zy_34", Zt = {
  root: hp,
  container: dp,
  label: pp,
  icon: mp
}, yi = "Tag";
function vi({
  as: t,
  iconPosition: e = "left",
  children: n,
  icon: s,
  className: r,
  animate: i = !0,
  animationDelay: o = 0,
  style: a,
  ...l
}, c) {
  const u = t || "span", f = i ? pt[u] : u, p = ht(l) ?? [], m = i ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: o, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ d.jsx(
    f,
    {
      ref: c,
      className: nt(
        Zt.root,
        "airc-ui__" + lt(yi),
        at(r),
        ...p
      ),
      "data-icon-position": e,
      ...a ? { style: a } : {},
      ...m,
      ...l,
      children: /* @__PURE__ */ d.jsxs("div", { className: Zt.container, children: [
        s ? /* @__PURE__ */ d.jsx("div", { className: Zt.icon, children: Jd(s) ? typeof s == "function" ? /* @__PURE__ */ d.jsx(s, { className: Zt.icon }) : (
          // This element would have its props baked-in, if any;
          // it's the responsibility of the library user to style this one.
          s
        ) : /* @__PURE__ */ d.jsx(ep, { className: Zt.icon, icon: s }) }) : null,
        /* @__PURE__ */ d.jsx("div", { className: Zt.label, children: n })
      ] })
    }
  );
}
vi.displayName = yi;
const Ep = S(vi), gp = "_root_10m5p_9", yp = "_image_10m5p_26", vp = "_info_10m5p_37", xp = "_title_10m5p_42", wp = "_subtitle_10m5p_43", ae = {
  root: gp,
  image: yp,
  info: vp,
  title: xp,
  subtitle: wp
}, xi = "Testimonial";
function wi({
  as: t,
  title: e,
  subtitle: n,
  image: s,
  altText: r = "Immagine del testimonial",
  className: i,
  animate: o = !0,
  animationDelay: a = 0,
  style: l,
  ...c
}, u) {
  const f = t || "div", p = o ? pt[f] : f, m = ht(c) ?? [], g = o ? {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { delay: a, duration: 0.3 }
  } : {};
  return /* @__PURE__ */ d.jsxs(
    p,
    {
      ref: u,
      className: nt(
        // The root class from our CSS module
        ae.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + lt(xi),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        at(i),
        ...m
      ),
      ...l ? { style: l } : {},
      ...g,
      ...c,
      children: [
        s ? /* @__PURE__ */ d.jsx("div", { className: ae.image, children: /* @__PURE__ */ d.jsx("img", { src: s, alt: r }) }) : null,
        /* @__PURE__ */ d.jsxs("div", { className: ae.info, children: [
          e ? /* @__PURE__ */ d.jsx("span", { className: ae.title, children: e }) : null,
          n ? /* @__PURE__ */ d.jsx("span", { className: ae.subtitle, children: n }) : null
        ] })
      ]
    }
  );
}
wi.displayName = xi;
const Dp = S(
  wi
);
export {
  Tp as A,
  jp as C,
  ep as I,
  Vp as O,
  Lp as P,
  Ep as T,
  Mp as a,
  Ap as b,
  Rp as c,
  rp as d,
  kp as e,
  Dp as f,
  Yi as g,
  ht as h,
  Mr as i,
  d as j,
  nt as k,
  at as l,
  pt as m,
  Jd as n,
  Pp as o,
  lt as p,
  Cp as q
};
//# sourceMappingURL=index-CoDGs-6l.js.map
